var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLatoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170910 at Tue Nov  8 20:07:42 2011\n By Jimmy W\xE4rting\nCopyright (c) 2010-2011 by tyPoland Lukasz Dziedzic with Reserved Font Name \"Lato\". Licensed under the SIL Open Font License, Version 1.1.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Lato-Black",
    horizAdvX: 1160
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Lato Black",
    fontWeight: 900,
    fontStretch: "normal",
    unitsPerEm: 2000,
    panose1: "2 15 10 2 2 2 4 3 2 3",
    ascent: 1610,
    descent: -390,
    xHeight: 1037,
    capHeight: 1457,
    bbox: "-166 -357 2334 1904",
    underlineThickness: 194,
    underlinePosition: -200,
    unicodeRange: "U+000D-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 1123,
    d: "M230 1152q62 48 140 79.5t183 31.5q78 0 137.5 -20t100.5 -56t62 -87t21 -113q0 -55 -13 -95t-32.5 -69t-43 -50t-45.5 -39t-39 -35t-23 -38l-27 -90h-212l-22 112q-8 39 1.5 66.5t28.5 49t43.5 39t46 36.5t36 41t14.5 53q0 23 -13 38.5t-49 15.5q-32 0 -53 -5 t-36.5 -11.5t-29 -11.5t-31.5 -5q-43 0 -63 36zM374 331q0 33 12 61.5t34 49.5t51 33t64 12q33 0 62 -12t50.5 -33t34 -49.5t12.5 -61.5t-12.5 -61.5t-34 -49.5t-50.5 -33t-62 -12q-35 0 -64 12t-51 33t-34 49.5t-12 61.5zM40 1457h1043v-1457h-1043v1457zM117 80h879v1297 h-879v-1297z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 1258,
    d: "M166 0v824l-68 14q-35 8 -56.5 25t-21.5 50v122h146v15q0 94 32.5 177.5t100.5 145t173.5 97.5t251.5 36q45 0 93 -4.5t83 -13.5l-10 -157q-2 -25 -25 -33t-49 -8q-104 0 -172 -16t-107.5 -47.5t-55 -78.5t-15.5 -108v-5h658v-1035h-310v823h-338v-823h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 1276,
    d: "M166 0v824l-68 14q-35 8 -56.5 25t-21.5 50v122h146v36q0 79 26 154.5t80 134t138 94t200 35.5q98 0 184.5 -6t175.5 -6h174v-1477h-308v1269q-51 2 -98.5 4.5t-77.5 2.5q-95 0 -144.5 -52.5t-49.5 -152.5v-36h224v-212h-214v-823h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 1123,
    d: "M230 1152q62 48 140 79.5t183 31.5q78 0 137.5 -20t100.5 -56t62 -87t21 -113q0 -55 -13 -95t-32.5 -69t-43 -50t-45.5 -39t-39 -35t-23 -38l-27 -90h-212l-22 112q-8 39 1.5 66.5t28.5 49t43.5 39t46 36.5t36 41t14.5 53q0 23 -13 38.5t-49 15.5q-32 0 -53 -5 t-36.5 -11.5t-29 -11.5t-31.5 -5q-43 0 -63 36zM374 331q0 33 12 61.5t34 49.5t51 33t64 12q33 0 62 -12t50.5 -33t34 -49.5t12.5 -61.5t-12.5 -61.5t-34 -49.5t-50.5 -33t-62 -12q-35 0 -64 12t-51 33t-34 49.5t-12 61.5zM40 1457h1043v-1457h-1043v1457zM117 80h879v1297 h-879v-1297z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    unicode: "\r",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 386
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 752,
    d: "M524 1457v-572q0 -92 -11 -182.5t-29 -184.5h-210q-18 94 -29 184.5t-11 182.5v572h290zM200 157q0 36 13.5 67t37 54t55.5 36.5t70 13.5q37 0 69 -13.5t56 -36.5t37.5 -54t13.5 -67t-13.5 -67.5t-37.5 -54.5t-56 -36t-69 -13q-38 0 -70 13t-55.5 36t-37 54.5t-13.5 67.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 890,
    d: "M380 1457v-286l-28 -158q-9 -54 -32 -82.5t-76 -28.5q-45 0 -70.5 28.5t-35.5 82.5l-28 158v286h270zM780 1457v-286l-28 -158q-9 -54 -32 -82.5t-76 -28.5q-45 0 -70.5 28.5t-35.5 82.5l-28 158v286h270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    d: "M862 395l-70 -395h-144q-19 0 -35.5 8t-28.5 21.5t-19 32t-7 39.5q0 5 0.5 11t1.5 11l48 272h-165l-49 -287q-5 -29 -18 -49.5t-32 -33.5t-41.5 -19t-46.5 -6h-138l70 395h-88q-38 0 -59 18.5t-21 62.5q0 9 1 19t3 21l16 96h177l42 236h-199l24 126q9 46 39.5 68t96.5 22 h68l52 293q8 47 45 73.5t85 26.5h142l-70 -393h166l70 393h138q44 0 71.5 -24t27.5 -62v-7.5t-1 -8.5l-52 -291h194l-24 -126q-9 -47 -39.5 -68.5t-96.5 -21.5h-63l-42 -236h109q38 0 59 -18.5t21 -62.5q0 -9 -1 -19t-3 -21l-16 -96h-198zM471 612h166l42 236h-166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    d: "M430 -5q-115 19 -219.5 66.5t-176.5 114.5l96 139q12 17 32.5 28.5t43.5 11.5q24 0 49 -12.5t54.5 -30.5t64.5 -36.5t80 -30.5l37 378q-72 20 -143 47t-128 73t-92.5 117t-35.5 178q0 79 32 154t93.5 135t151.5 98.5t206 44.5l11 111q3 28 25 50.5t57 22.5h114l-20 -197 q108 -20 186 -64.5t132 -95.5l-76 -111q-17 -25 -34.5 -36.5t-41.5 -11.5q-16 0 -36 7t-44 17.5t-51.5 22.5t-58.5 21l-35 -355q48 -14 96 -30.5t92.5 -38t83 -49.5t67 -66t44.5 -87.5t16 -112.5q0 -95 -32 -178.5t-94 -147.5t-152 -104.5t-206 -49.5l-12 -125 q-3 -28 -25 -50.5t-57 -22.5h-114zM808 421q0 57 -36.5 91t-96.5 57l-32 -330q165 29 165 182zM384 1068q0 -59 37.5 -95.5t98.5 -61.5l30 302q-46 -7 -77.5 -20.5t-51 -32.5t-28.5 -42.5t-9 -49.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 1636,
    d: "M748 1104q0 -80 -29 -146t-77 -113.5t-111.5 -73.5t-132.5 -26q-76 0 -139.5 26t-110 73.5t-72.5 113.5t-26 146q0 83 26 150.5t72.5 115.5t110 74.5t139.5 26.5t140.5 -26.5t111 -74.5t72.5 -115.5t26 -150.5zM510 1104q0 51 -8.5 84.5t-23.5 53.5t-35.5 28t-44.5 8 t-44 -8t-34 -28t-22 -53.5t-8 -84.5q0 -48 8 -80t22 -51t34 -27t44 -8t44.5 8t35.5 27t23.5 51t8.5 80zM1206 1411q15 17 37 31.5t61 14.5h226l-1098 -1413q-15 -19 -37.5 -31.5t-54.5 -12.5h-232zM1586 342q0 -80 -29 -146.5t-77 -114t-111.5 -73.5t-132.5 -26 q-76 0 -139.5 26t-110 73.5t-72.5 114t-26 146.5q0 83 26 150.5t72.5 115.5t110 74.5t139.5 26.5t140.5 -26.5t111 -74.5t72.5 -115.5t26 -150.5zM1348 342q0 50 -8.5 83.5t-23.5 53.5t-35.5 28t-44.5 8t-44 -8t-34 -28t-22 -53.5t-8 -83.5q0 -48 8 -80t22 -51t34 -27t44 -8 t44.5 8t35.5 27t23.5 51t8.5 80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 1446,
    d: "M664 1473q97 0 171 -28.5t125 -75t80 -107.5t36 -125l-200 -40q-5 -1 -8.5 -1.5t-7.5 -0.5q-42 0 -62 44q-23 52 -53.5 79t-80.5 27q-35 0 -61 -13t-43.5 -34t-26.5 -49t-9 -58q0 -26 4.5 -50t15 -48.5t29 -50.5t47.5 -56l360 -380q27 60 43 125t23 135q2 28 18.5 44 t43.5 16h196q0 -146 -39 -272.5t-111 -231.5l306 -322h-306q-23 0 -41 2.5t-33.5 8.5t-29.5 17t-30 28l-63 66q-95 -66 -207.5 -102t-239.5 -36q-87 0 -170.5 30t-148.5 85.5t-105 134.5t-40 177q0 66 20.5 125t57.5 109.5t88.5 92t112.5 72.5q-47 73 -68 143t-21 136 q0 78 28.5 147.5t83 122t134 83.5t182.5 31zM362 436q0 -48 14.5 -87t41.5 -67t64.5 -43.5t83.5 -15.5q67 0 124.5 17.5t107.5 49.5l-335 355q-55 -45 -78 -98t-23 -111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 490,
    d: "M380 1457v-286l-28 -158q-9 -54 -32 -82.5t-76 -28.5q-45 0 -70.5 28.5t-35.5 82.5l-28 158v286h270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 600,
    d: "M348 626q0 -99 11.5 -199t34 -197t55 -189t73.5 -176q14 -29 14 -53t-13 -39t-31 -26l-138 -80q-73 112 -125 228t-85 235.5t-48.5 243.5t-15.5 252t15.5 252t48.5 243.5t85 235.5t125 229l138 -80q17 -11 30 -26t13 -38q0 -11 -3.5 -24t-11.5 -29q-42 -83 -74 -175.5 t-54 -190t-33 -198t-11 -199.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 600,
    d: "M252 626q0 99 -11 199.5t-33 198t-54 190t-74 175.5q-8 16 -11.5 29t-3.5 24q0 23 13 38t30 26l138 80q145 -226 209.5 -465t64.5 -495q0 -257 -64.5 -495.5t-209.5 -463.5l-138 80q-18 11 -31 26t-13 39t14 53q41 84 73.5 176t55 189t34 197t11.5 199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 800,
    d: "M326 815v173q0 20 2.5 40.5t8.5 37.5q-13 -14 -29 -25t-34 -22l-146 -85l-72 119l146 85q19 11 38 19t39 12q-20 4 -39 12.5t-38 19.5l-146 87l72 120l146 -88q18 -11 34.5 -22.5t29.5 -25.5q-12 34 -12 77v175h146v-173q0 -21 -2.5 -41t-8.5 -38q13 14 29 25.5t34 22.5 l146 86l72 -120l-146 -85q-20 -11 -39 -19t-39 -12q20 -4 39.5 -12.5t38.5 -19.5l146 -87l-72 -119l-146 87q-19 11 -35 22.5t-30 25.5q13 -35 13 -77v-175h-146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    d: "M704 1179v-396h370v-222h-370v-398h-252v398h-368v222h368v396h252z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 472,
    d: "M68 176q0 32 12 59.5t34.5 48t53 32.5t68.5 12q45 0 78 -15.5t55 -42t32.5 -61t10.5 -72.5q0 -50 -16 -106.5t-47.5 -113.5t-78.5 -112t-108 -100l-54 48q-11 11 -16.5 20.5t-5.5 23.5q0 10 7 21.5t17 20.5q12 12 28 29t32 38t29.5 46t20.5 53q-35 3 -63 17t-47.5 37 t-30.5 52.5t-11 64.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 740,
    d: "M100 733h540v-250h-540v250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 472,
    d: "M60 157q0 36 13.5 67t37 54t55.5 36.5t70 13.5q37 0 69 -13.5t56 -36.5t37.5 -54t13.5 -67t-13.5 -67.5t-37.5 -54.5t-56 -36t-69 -13q-38 0 -70 13t-55.5 36t-37 54.5t-13.5 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 800,
    d: "M270 12q-11 -27 -28.5 -48t-39 -35t-46 -21t-48.5 -7h-132l568 1491q20 51 61 78t95 27h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    d: "M1120 729q0 -191 -41 -331t-113.5 -232t-172 -137t-215.5 -45t-214.5 45t-170.5 137t-112.5 232t-40.5 331t40.5 331t112.5 232t170.5 136.5t214.5 44.5t215.5 -44.5t172 -136.5t113.5 -232t41 -331zM800 729q0 151 -19 247.5t-50.5 151.5t-71.5 75.5t-81 20.5 t-80.5 -20.5t-70 -75.5t-49 -151.5t-18.5 -247.5q0 -152 18.5 -248t49 -151.5t70 -76t80.5 -20.5t81 20.5t71.5 76t50.5 151.5t19 248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    d: "M252 224h280v735q0 54 3 113l-165 -137q-16 -13 -32 -18.5t-31 -5.5q-26 0 -46.5 11.5t-30.5 24.5l-98 130l454 381h256v-1234h240v-224h-830v224z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    d: "M602 1473q108 0 194.5 -31.5t147.5 -87.5t93.5 -133.5t32.5 -170.5q0 -80 -22.5 -148t-61.5 -129.5t-90.5 -119t-109.5 -116.5l-285 -292q55 16 108.5 25.5t100.5 9.5h272q50 0 79 -27.5t29 -72.5v-180h-1024v100q0 29 12 62t42 60l420 423q54 54 94 103t66 96.5t39 95 t13 100.5q0 87 -41.5 133.5t-126.5 46.5q-35 0 -64 -10t-52 -27t-39.5 -40t-26.5 -50q-16 -45 -40.5 -65t-66.5 -20q-10 0 -21.5 1t-23.5 3l-164 29q16 109 61.5 190t113 135t154.5 80.5t187 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    d: "M630 1473q108 0 192 -30.5t142 -82.5t88 -120.5t30 -144.5q0 -69 -14 -121.5t-41.5 -91t-68 -65.5t-92.5 -45q242 -84 242 -329q0 -116 -42 -202t-112.5 -143t-163.5 -85.5t-194 -28.5q-104 0 -185 22.5t-144 70t-110.5 121.5t-82.5 176l138 56q18 8 35.5 11t34.5 3 q32 0 57.5 -12.5t38.5 -36.5q45 -83 95.5 -120.5t118.5 -37.5q52 0 90.5 17.5t64 45t38.5 62.5t13 71q0 47 -6.5 84.5t-36.5 64.5t-90.5 41.5t-168.5 14.5v214q91 0 147 14t86.5 38.5t40.5 59.5t10 77q0 86 -41.5 132.5t-126.5 46.5q-35 0 -64 -10t-52 -27t-39.5 -40 t-26.5 -50q-16 -45 -40.5 -65t-66.5 -20q-10 0 -21.5 1t-23.5 3l-164 29q16 109 61.5 190t113 135t154.5 80.5t187 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    d: "M976 566h150v-174q0 -23 -15.5 -40t-44.5 -17h-90v-335h-270v335h-586q-29 0 -52.5 18t-29.5 45l-32 153l674 906h296v-891zM706 946q0 35 2.5 75.5t7.5 83.5l-385 -539h375v380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    d: "M998 1329q0 -32 -10 -58t-31.5 -45.5t-56.5 -30t-84 -10.5h-348l-41 -241q41 7 79 10.5t74 3.5q115 0 203 -35t148 -95.5t90.5 -142t30.5 -174.5q0 -117 -41.5 -213.5t-115.5 -166.5t-176.5 -108.5t-224.5 -38.5q-71 0 -135.5 15t-121 40.5t-104.5 59t-87 71.5l96 128 q15 20 35 30.5t43 10.5q30 0 56.5 -16.5t58 -36t73.5 -35.5t104 -16t106 20.5t71.5 56t40 83t12.5 101.5q0 106 -60 161.5t-170 55.5q-98 0 -192 -37l-192 52l124 729h746v-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    d: "M688 923q79 0 156 -26t138 -80t98.5 -136.5t37.5 -194.5q0 -102 -38 -193.5t-107.5 -160t-167.5 -108.5t-217 -40q-122 0 -219 38.5t-164.5 107.5t-103 165t-35.5 211q0 109 42 217t124 220l328 443q22 30 66 50.5t100 20.5h276l-432 -516q-10 -11 -19.5 -22.5 t-18.5 -22.5q35 13 73.5 20t82.5 7zM364 464q0 -54 13 -97t40 -74t68 -47.5t97 -16.5q48 0 89.5 18t71.5 49.5t47.5 74t17.5 92.5q0 56 -16.5 100t-46.5 74t-72.5 46t-94.5 16q-47 0 -86 -16.5t-67.5 -47.5t-44.5 -74t-16 -97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    d: "M1106 1457v-130q0 -55 -12 -89t-23 -58l-509 -1078q-20 -43 -59 -72.5t-103 -29.5h-226l520 1043q21 43 45.5 77t53.5 65h-641q-14 0 -26.5 5.5t-22 15t-15.5 22t-6 25.5v204h1024z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    d: "M580 -16q-116 0 -212 31t-164.5 87.5t-106 136.5t-37.5 178q0 59 13.5 111.5t43 96t76 77.5t112.5 57q-100 45 -148.5 125t-48.5 192q0 85 35 157.5t98 125.5t149.5 83.5t189.5 30.5t189.5 -30.5t149.5 -83.5t98 -125.5t35 -157.5q0 -112 -49 -192t-148 -125 q65 -23 111.5 -57t76 -77.5t43.5 -96t14 -111.5q0 -98 -37.5 -178t-106 -136.5t-164.5 -87.5t-212 -31zM580 218q52 0 90 16t62.5 43.5t36 65t11.5 80.5q0 47 -10 86t-33 66.5t-61.5 43t-95.5 15.5t-95.5 -15.5t-61.5 -43t-33 -66.5t-10 -86q0 -43 11.5 -80.5t36 -65 t62 -43.5t90.5 -16zM580 870q52 0 85 17t52 45t26 64t7 74q0 34 -9 66t-29.5 56.5t-53 39.5t-78.5 15q-47 0 -79 -15t-52.5 -39.5t-29.5 -56.5t-9 -66q0 -38 7 -74t26 -64t52 -45t85 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    d: "M512 568q-71 0 -142 25.5t-128.5 77.5t-93.5 131t-36 187q0 99 36.5 187t104 154t161.5 104.5t210 38.5q118 0 211 -36t157.5 -101t99 -154.5t34.5 -197.5q0 -72 -11.5 -135t-32 -120.5t-49.5 -110t-65 -103.5l-314 -446q-20 -29 -63 -49t-97 -20h-286l462 552 q14 17 26.5 32.5t24.5 31.5q-45 -24 -98 -36t-111 -12zM830 1012q0 53 -15.5 93.5t-43 67.5t-66.5 41t-85 14q-47 0 -83.5 -16.5t-62 -45.5t-39 -68.5t-13.5 -85.5q0 -218 202 -218q99 0 152.5 59.5t53.5 158.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 552,
    d: "M100 157q0 36 13.5 67t37 54t55.5 36.5t70 13.5q37 0 69 -13.5t56 -36.5t37.5 -54t13.5 -67t-13.5 -67.5t-37.5 -54.5t-56 -36t-69 -13q-38 0 -70 13t-55.5 36t-37 54.5t-13.5 67.5zM100 840q0 36 13.5 67t37 54t55.5 36.5t70 13.5q37 0 69 -13.5t56 -36.5t37.5 -54 t13.5 -67t-13.5 -67.5t-37.5 -54.5t-56 -36t-69 -13q-38 0 -70 13t-55.5 36t-37 54.5t-13.5 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 552,
    d: "M108 176q0 32 12 59.5t34.5 48t53 32.5t68.5 12q45 0 78 -15.5t55 -42t32.5 -61t10.5 -72.5q0 -50 -16 -106.5t-47.5 -113.5t-78.5 -112t-108 -100l-54 48q-11 11 -16.5 20.5t-5.5 23.5q0 10 7 21.5t17 20.5q12 12 28 29t32 38t29.5 46t20.5 53q-35 3 -63 17t-47.5 37 t-30.5 52.5t-11 64.5zM100 840q0 36 13.5 67t37 54t55.5 36.5t70 13.5q37 0 69 -13.5t56 -36.5t37.5 -54t13.5 -67t-13.5 -67.5t-37.5 -54.5t-56 -36t-69 -13q-38 0 -70 13t-55.5 36t-37 54.5t-13.5 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    d: "M130 735l810 424v-215q0 -23 -12 -42.5t-38 -33.5l-284 -153q-26 -14 -55 -23.5t-61 -17.5q32 -8 61 -16.5t55 -22.5l284 -154q26 -14 38 -33t12 -42v-215l-810 423v121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    d: "M124 599h910v-222h-910v222zM124 966h910v-223h-910v223z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    d: "M1030 614l-810 -423v215q0 23 12 42t38 33l284 154q25 14 54.5 22.5t61.5 16.5q-32 8 -61.5 17.5t-54.5 23.5l-284 153q-26 14 -38 33.5t-12 42.5v215l810 -424v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 882,
    d: "M38 1324q37 31 80.5 58t93.5 47.5t107.5 32t124.5 11.5q94 0 169.5 -25t128.5 -71.5t81.5 -112t28.5 -145.5q0 -77 -21 -132t-53.5 -96t-71 -70.5t-73 -55.5t-60 -51t-31.5 -56l-28 -140h-212l-22 161q-1 6 -1.5 12t-0.5 12q0 44 21 77t53 60.5t69 53t69 55t53 66 t21 86.5q0 60 -39.5 95.5t-108.5 35.5q-53 0 -88.5 -11t-61 -24.5t-44.5 -24.5t-38 -11q-43 0 -64 37zM222 157q0 36 13.5 67t37 54t55.5 36.5t70 13.5q37 0 69 -13.5t56 -36.5t37.5 -54t13.5 -67t-13.5 -67.5t-37.5 -54.5t-56 -36t-69 -13q-38 0 -70 13t-55.5 36t-37 54.5 t-13.5 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 1646,
    d: "M1166 182q-32 0 -62 6.5t-56.5 21t-48 38t-34.5 57.5q-60 -66 -125 -94t-140 -28q-65 0 -114 22.5t-82 62.5t-49.5 95t-16.5 120q0 57 14.5 116t43.5 113.5t73.5 103t104.5 84t136.5 56.5t169.5 21q44 0 80 -3.5t67 -9.5t58.5 -15.5t56.5 -21.5l-98 -379q-15 -59 -15 -94 q0 -50 22.5 -69t60.5 -19q36 0 67.5 25.5t54.5 70.5t36.5 106t13.5 133q0 124 -37 218.5t-105.5 158.5t-165 97t-214.5 33q-129 0 -237 -48t-186 -131.5t-121.5 -195t-43.5 -238.5q0 -160 48.5 -281t134 -202t203 -121.5t254.5 -40.5q79 0 145.5 8.5t120.5 22t96 30.5t72 34 q22 12 41 12q35 0 49 -37l42 -108q-50 -33 -110.5 -61t-131 -49t-151.5 -32.5t-173 -11.5q-188 0 -346 58.5t-273.5 167.5t-180 264t-64.5 347q0 105 28 206t80 190t125 164t163 129.5t195 84.5t221 30q97 0 189.5 -22t175 -64t152 -103t119.5 -138.5t78 -171t28 -199.5 q0 -107 -32.5 -201.5t-91 -165t-139 -111.5t-175.5 -41zM762 374q22 0 43.5 7t40.5 23.5t34.5 43.5t25.5 67l70 273q-24 3 -48 3q-50 0 -96 -24t-80.5 -65t-55 -95.5t-20.5 -115.5q0 -59 22.5 -88t63.5 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 1474,
    d: "M1476 0h-262q-44 0 -72.5 20.5t-39.5 52.5l-86 254h-554l-86 -254q-10 -28 -39 -50.5t-71 -22.5h-264l564 1457h346zM540 557h398l-134 399q-13 38 -30.5 89.5t-34.5 111.5q-16 -61 -33 -113t-32 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 1312,
    d: "M120 0v1457h536q151 0 257 -28t173 -79t97.5 -124t30.5 -163q0 -49 -14 -94.5t-44 -85.5t-77 -72.5t-113 -56.5q144 -35 213 -113.5t69 -201.5q0 -93 -36 -173t-105.5 -139.5t-171.5 -93t-233 -33.5h-582zM458 618v-363h238q67 0 109.5 17t66.5 44t33 61t9 69 q0 40 -10.5 72t-36 54t-67.5 34t-106 12h-236zM458 844h176q56 0 101 8t76.5 28t48 55t16.5 88q0 52 -13 86.5t-40 55.5t-68.5 30t-98.5 9h-198v-360z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 1314,
    d: "M1099 377q12 0 24 -4.5t23 -15.5l134 -141q-88 -115 -220.5 -173.5t-313.5 -58.5q-166 0 -297.5 56.5t-223 156t-140.5 236t-49 296.5q0 163 56 299.5t156.5 235.5t240.5 154t309 55q82 0 154.5 -14.5t135.5 -40t116 -61t94 -78.5l-114 -153q-11 -14 -26 -25.5t-42 -11.5 q-18 0 -34 8t-34 19.5t-39.5 25t-51 25t-69 19.5t-92.5 8q-92 0 -168 -32.5t-130.5 -93t-85 -146.5t-30.5 -193q0 -112 30.5 -199t83 -146.5t122.5 -90.5t150 -31q46 0 84 4.5t70.5 15.5t62 28.5t59.5 43.5q12 10 26 16.5t29 6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 1484,
    d: "M1442 729q0 -158 -54.5 -291.5t-153.5 -231t-238.5 -152t-309.5 -54.5h-566v1457h566q170 0 309.5 -55t238.5 -152t153.5 -230.5t54.5 -290.5zM1096 729q0 108 -28 195t-80.5 147.5t-128.5 93t-173 32.5h-226v-937h226q97 0 173 32.5t128.5 93t80.5 147.5t28 196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 1130,
    d: "M1058 1457v-260h-598v-340h458v-250h-458v-347h598v-260h-938v1457h938z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 1114,
    d: "M1058 1457v-260h-598v-369h498v-261h-498v-567h-340v1457h938z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 1424,
    d: "M806 244q70 0 124 12t102 32v221h-144q-32 0 -50 17t-18 43v186h518v-615q-56 -41 -116.5 -70.5t-129 -48.5t-146 -28t-166.5 -9q-160 0 -296 56.5t-235.5 156t-156 236t-56.5 296.5q0 163 54 299.5t154.5 235.5t243 154t318.5 55q91 0 171 -15t147.5 -41t123.5 -62 t100 -78l-98 -149q-14 -21 -33.5 -33t-42.5 -12q-30 0 -62 20q-40 24 -75.5 41.5t-72.5 28.5t-78 16t-92 5q-95 0 -171 -33.5t-129.5 -94.5t-82.5 -146.5t-29 -190.5q0 -116 32 -206t88.5 -152t134 -94.5t169.5 -32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 1512,
    d: "M1392 0h-340v616h-592v-616h-340v1457h340v-609h592v609h340v-1457z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 640,
    d: "M490 0h-340v1457h340v-1457z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 860,
    d: "M740 528q0 -122 -30.5 -222t-92 -171.5t-154.5 -111t-219 -39.5q-57 0 -112.5 6t-115.5 20l18 197q2 26 20.5 42t51.5 16q17 0 42 -5.5t60 -5.5q49 0 85.5 13.5t60.5 45t36 82.5t12 126v936h338v-929z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 1428,
    d: "M458 867h54q75 0 108 47l328 476q27 39 61.5 53t84.5 14h294l-432 -589q-23 -32 -48 -53t-51 -35q38 -14 69.5 -38.5t57.5 -65.5l440 -676h-302q-29 0 -49.5 4t-35.5 12t-26 19.5t-21 26.5l-330 507q-18 28 -45.5 39.5t-74.5 11.5h-82v-620h-338v1457h338v-590z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 1038,
    d: "M458 270h540v-270h-878v1457h338v-1187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 1878,
    d: "M865 666q20 -38 38.5 -79t35.5 -84q17 44 36 85.5t39 80.5l374 736q10 19 20.5 29.5t23.5 15.5t29.5 6t38.5 1h258v-1457h-298v838q0 61 6 132l-386 -749q-18 -35 -48.5 -53t-69.5 -18h-46q-39 0 -69.5 18t-48.5 53l-388 750q4 -35 6 -69.5t2 -63.5v-838h-298v1457h258 q22 0 38.5 -1t29.5 -6t23.5 -15.5t20.5 -29.5l375 -739v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 1512,
    d: "M298 1457q22 0 37 -2t27 -7.5t23 -15.5t25 -27l692 -875q-4 42 -6 81.5t-2 74.5v771h298v-1457h-176q-39 0 -66 12t-52 44l-687 868q3 -38 5 -74.5t2 -68.5v-781h-298v1457h178v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 1600,
    d: "M1558 729q0 -158 -54.5 -294t-153.5 -236.5t-238.5 -157.5t-309.5 -57t-310 57t-239.5 157.5t-154 236.5t-54.5 294t54.5 294t154 236t239.5 157t310 57t309.5 -57.5t238.5 -157.5t153.5 -236t54.5 -293zM1212 729q0 108 -28 194.5t-80.5 146.5t-128.5 92t-173 32 q-98 0 -174.5 -32t-129 -92t-80.5 -146.5t-28 -194.5q0 -109 28 -195.5t80.5 -146.5t129 -91.5t174.5 -31.5q97 0 173 31.5t128.5 91.5t80.5 146.5t28 195.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 1276,
    d: "M458 487v-487h-338v1457h514q154 0 264.5 -36.5t182 -100.5t105.5 -151t34 -188q0 -109 -35 -200t-107 -156t-182.5 -101.5t-261.5 -36.5h-176zM458 742h176q132 0 190 63t58 176q0 50 -15 91t-45.5 70.5t-77 45.5t-110.5 16h-176v-462z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 1600,
    d: "M1558 729q0 -94 -19.5 -180.5t-56 -162.5t-90 -141t-121.5 -115l369 -403h-278q-60 0 -109 14.5t-87 58.5l-181 203q-44 -9 -89.5 -14t-93.5 -5q-170 0 -310 57t-239.5 157.5t-154 236.5t-54.5 294t54.5 294t154 236t239.5 157t310 57t309.5 -57.5t238.5 -157.5 t153.5 -236t54.5 -293zM1212 729q0 108 -28 194.5t-80.5 146.5t-128.5 92t-173 32q-98 0 -174.5 -32t-129 -92t-80.5 -146.5t-28 -194.5q0 -109 28 -195.5t80.5 -146.5t129 -91.5t174.5 -31.5q97 0 173 31.5t128.5 91.5t80.5 146.5t28 195.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 1330,
    d: "M458 539v-539h-338v1457h474q158 0 269.5 -32.5t182 -90.5t102.5 -137t32 -172q0 -71 -19 -134t-56.5 -116.5t-92 -95.5t-125.5 -69q34 -17 63.5 -42t51.5 -61l310 -507h-306q-85 0 -122 64l-242 423q-16 28 -37.5 40t-60.5 12h-86zM458 772h136q69 0 117.5 17.5 t79.5 48.5t45 72.5t14 89.5q0 96 -62.5 150t-193.5 54h-136v-432z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 1084,
    d: "M932 1161q-15 -24 -31.5 -36t-42.5 -12q-23 0 -49.5 14.5t-60 32.5t-76.5 32.5t-98 14.5q-95 0 -141.5 -40.5t-46.5 -109.5q0 -44 28 -73t73.5 -50t104 -38.5t119.5 -39t119.5 -50.5t104 -74t73.5 -109.5t28 -155.5q0 -101 -35 -189t-101.5 -153.5t-164 -103 t-221.5 -37.5q-68 0 -138.5 14t-136.5 39.5t-124 60.5t-101 78l100 158q11 18 31 29t43 11q30 0 60.5 -19t69 -42t88.5 -42t118 -19q92 0 143 40.5t51 128.5q0 51 -28 83t-73.5 53t-103.5 37t-119 35.5t-119 48t-103.5 75t-73.5 116t-28 171.5q0 82 33 160t97 139t157 97.5 t213 36.5q67 0 130.5 -10.5t120.5 -31t106.5 -49t88.5 -64.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 1198,
    d: "M1178 1457v-268h-410v-1189h-338v1189h-410v268h1158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 1452,
    d: "M726 267q68 0 121.5 22.5t90.5 64.5t56.5 102.5t19.5 137.5v863h338v-863q0 -134 -43.5 -246t-124.5 -193t-197 -126t-261 -45q-146 0 -262 45t-197 126t-124 193t-43 246v863h338v-862q0 -77 19.5 -137.5t56.5 -103t90.5 -65t121.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 1474,
    d: "M0 1457h272q44 0 72 -20t40 -53l282 -780q19 -51 38.5 -111t36.5 -126q14 66 32.5 126t36.5 111l280 780q10 28 39 50.5t71 22.5h274l-584 -1457h-306z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 2142,
    d: "M10 1457h284q44 0 73.5 -20t38.5 -53l200 -760q10 -37 20 -79t15 -88q10 47 22 88.5t23 78.5l236 760q9 28 38.5 50.5t71.5 22.5h100q44 0 72.5 -19.5t39.5 -53.5l234 -760q11 -35 23 -74.5t21 -84.5q8 44 16.5 84t17.5 75l200 760q8 29 38 51t72 22h266l-450 -1457h-306 l-274 903q-7 21 -14.5 46t-14.5 53q-7 -28 -14.5 -53t-14.5 -46l-278 -903h-306z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 1424,
    d: "M479 749l-451 708h338q33 0 48.5 -8.5t27.5 -28.5l290 -491q5 13 11.5 25t14.5 25l254 436q25 42 68 42h324l-457 -693l467 -764h-338q-33 0 -53.5 16t-32.5 38l-292 510q-8 -22 -18 -38l-272 -472q-12 -21 -32 -37.5t-50 -16.5h-316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 1354,
    d: "M846 554v-554h-338v554l-528 903h298q44 0 70 -20.5t42 -52.5l206 -424q25 -51 46 -94t37 -85q15 43 36 86t45 93l204 424q6 13 16.5 26t24 23.5t31 17t38.5 6.5h300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 1220,
    d: "M1186 1457v-122q0 -26 -8.5 -51t-23.5 -47l-684 -977h694v-260h-1124v130q0 23 8 45.5t22 41.5l686 980h-660v260h1090z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 600,
    d: "M90 -324v1881h448v-118q0 -31 -22.5 -53t-57.5 -22h-110v-1495h110q35 0 57.5 -22t22.5 -52v-119h-448z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 808,
    d: "M-36 1497h132q54 0 95 -27t61 -78l568 -1491h-132q-24 0 -48.5 7t-46 21t-39.5 35t-28 48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 600,
    d: "M62 1557h448v-1881h-448v119q0 30 22.5 52t57.5 22h110v1495h-110q-35 0 -57.5 22t-22.5 53v118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    d: "M1062 768h-228q-27 0 -45 13.5t-29 34.5l-124 237q-17 32 -31.5 61t-25.5 58q-10 -29 -23 -58t-30 -61l-120 -237q-11 -20 -29.5 -34t-48.5 -14h-240l386 689h202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 788,
    d: "M788 -108v-194h-788v194h788z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 660,
    d: "M252 1473q47 0 70 -15.5t40 -44.5l136 -245h-176q-35 0 -56 9.5t-44 32.5l-260 263h290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 1078,
    d: "M836 0q-44 0 -66.5 12t-37.5 50l-22 57q-39 -33 -75 -58t-74.5 -42.5t-82 -26t-96.5 -8.5q-71 0 -129 18.5t-98.5 54.5t-62.5 89.5t-22 123.5q0 55 28 113t97 105.5t186 79.5t295 36v44q0 91 -37.5 131.5t-106.5 40.5q-55 0 -90 -12t-62.5 -27t-53.5 -27t-62 -12 q-32 0 -54.5 15.5t-35.5 38.5l-56 97q94 83 208.5 123.5t245.5 40.5q94 0 169.5 -30.5t128 -85t80.5 -129.5t28 -164v-648h-142zM480 189q60 0 105 21t91 68v144q-93 -4 -153 -16t-95 -30t-48.5 -41t-13.5 -50q0 -53 29 -74.5t85 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    d: "M120 0v1497h310v-570q58 57 131.5 91.5t172.5 34.5q81 0 150 -35t119 -102.5t78.5 -165.5t28.5 -223q0 -117 -32.5 -216t-91 -172t-140 -114t-180.5 -41q-46 0 -82.5 9t-67 25.5t-56 39.5t-49.5 50l-11 -52q-7 -32 -25.5 -44t-48.5 -12h-206zM626 820q-34 0 -61.5 -6.5 t-51 -18.5t-43.5 -30.5t-40 -42.5v-440q35 -39 76 -54.5t86 -15.5q43 0 79 17t62.5 54.5t41.5 97.5t15 146q0 82 -12 138t-33.5 90.5t-51.5 49.5t-67 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 972,
    d: "M868 791q-14 -17 -27 -27t-37 -10q-23 0 -41.5 11t-41.5 24.5t-54 24.5t-77 11q-57 0 -98.5 -21t-68.5 -60t-40 -95.5t-13 -127.5q0 -149 57.5 -229t158.5 -80q54 0 85.5 13.5t53.5 30t40.5 30.5t46.5 14q37 0 56 -27l90 -111q-48 -55 -101 -89.5t-108.5 -54t-111.5 -27 t-109 -7.5q-95 0 -181.5 36t-152 104.5t-104 168.5t-38.5 228q0 112 33.5 209.5t99 169t162 112.5t223.5 41q122 0 214 -39t166 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M848 0q-29 0 -48.5 13t-27.5 39l-24 79q-31 -33 -65 -60t-73.5 -46.5t-85 -30t-98.5 -10.5q-81 0 -150 36t-119 104t-78.5 166.5t-28.5 224.5q0 116 32 215.5t90.5 172t140.5 113.5t181 41q80 0 135.5 -23.5t100.5 -61.5v525h310v-1497h-192zM534 222q34 0 61.5 6.5 t50.5 18.5t43.5 30t40.5 42v440q-36 39 -76.5 54.5t-85.5 15.5q-43 0 -79 -17t-62.5 -54.5t-41.5 -97.5t-15 -145q0 -82 12 -138t33.5 -90.5t51.5 -49.5t67 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 1088,
    d: "M564 1053q103 0 188.5 -32t147 -93t96 -149.5t34.5 -200.5q0 -35 -3 -57t-11 -35t-21.5 -18t-34.5 -5h-598q15 -130 79 -188.5t165 -58.5q54 0 93 13t69.5 29t56 29t53.5 13q37 0 56 -27l90 -111q-48 -55 -103.5 -89.5t-114 -54t-117 -27t-111.5 -7.5q-109 0 -204.5 35.5 t-167 105.5t-113 174t-41.5 242q0 104 35.5 197t102 163t161 111t213.5 41zM570 839q-89 0 -139 -50.5t-66 -145.5h387q0 37 -9.5 72t-31 62.5t-56.5 44.5t-85 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 724,
    d: "M166 0v824l-68 14q-35 8 -56.5 25t-21.5 50v122h146v59q0 89 28.5 161t82 123t130.5 79t175 28q38 0 70.5 -4.5t67.5 -14.5l-6 -151q-1 -16 -8.5 -26.5t-18.5 -17t-24.5 -9.5t-26.5 -3q-41 0 -73 -8t-53.5 -28.5t-32.5 -54t-11 -84.5v-49h244v-212h-234v-823h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 1046,
    d: "M486 1055q66 0 124.5 -13t108.5 -37h313v-113q0 -26 -14.5 -41t-49.5 -23l-76 -17q14 -45 14 -93q0 -78 -32.5 -140t-89 -105.5t-133.5 -67t-165 -23.5q-49 0 -92 6q-34 -20 -34 -46t27.5 -37.5t72.5 -16t103 -6t118 -7t118 -18.5t103 -42t72.5 -77.5t27.5 -123.5 q0 -70 -34 -137t-100 -119t-162 -83.5t-220 -31.5q-122 0 -210.5 23t-147 60.5t-86.5 86.5t-28 102q0 69 42 116.5t115 74.5q-35 23 -56 59t-21 91q0 23 8 48.5t25 49.5t43 46t62 39q-81 43 -127.5 114t-46.5 165q0 78 33 140.5t90.5 106t135.5 67t169 23.5zM716 -38 q0 25 -15.5 40t-42 24t-62 13t-76.5 6t-85 3.5t-87 6.5q-29 -20 -47.5 -44.5t-18.5 -55.5q0 -22 9.5 -40t33.5 -31t64.5 -20.5t102.5 -7.5q67 0 110 8t68.5 22t35.5 33.5t10 42.5zM486 573q77 0 111.5 38.5t34.5 99.5q0 63 -34.5 99t-111.5 36t-111.5 -36t-34.5 -99 q0 -30 8.5 -55t26.5 -43.5t45.5 -29t65.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    d: "M120 0v1497h310v-551q56 48 121.5 77.5t156.5 29.5q85 0 150.5 -29.5t110.5 -82t68 -125t23 -157.5v-659h-310v659q0 76 -35 118.5t-103 42.5q-51 0 -96 -22t-86 -59v-739h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 570,
    d: "M440 1037v-1037h-310v1037h310zM476 1321q0 -37 -15 -69.5t-41 -57t-60.5 -39t-73.5 -14.5q-38 0 -71 14.5t-58.5 39t-40 57t-14.5 69.5q0 38 14.5 71t40 58t58.5 39t71 14q39 0 73.5 -14t60.5 -39t41 -58t15 -71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 566,
    d: "M440 1037v-1039q0 -73 -18.5 -137.5t-61 -113t-112 -76.5t-172.5 -28q-38 0 -70.5 4.5t-67.5 13.5l10 163q2 21 14 31t48 10t59 6t36.5 21t19 40.5t5.5 65.5v1039h310zM476 1321q0 -37 -15 -69.5t-41 -57t-60.5 -39t-73.5 -14.5q-38 0 -71 14.5t-58.5 39t-40 57 t-14.5 69.5q0 38 14.5 71t40 58t58.5 39t71 14q39 0 73.5 -14t60.5 -39t41 -58t15 -71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 1152,
    d: "M430 1497v-839h46q29 0 44.5 8t29.5 29l196 292q17 26 40.5 38t59.5 12h284l-268 -369q-19 -26 -41.5 -46t-48.5 -36q45 -34 78 -90l292 -496h-280q-35 0 -60.5 11.5t-41.5 40.5l-196 367q-14 25 -29 32.5t-45 7.5h-60v-459h-310v1497h310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 570,
    d: "M440 1497v-1497h-310v1497h310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 1722,
    d: "M120 0v1037h192q29 0 48.5 -13t27.5 -39l17 -56q26 27 54 49.5t60.5 39t70 26t82.5 9.5q94 0 155.5 -48.5t93.5 -129.5q26 48 63.5 82t81 55t92 31t96.5 10q89 0 158 -26.5t115.5 -77t70.5 -124t24 -166.5v-659h-310v659q0 161 -138 161q-63 0 -104.5 -41.5t-41.5 -119.5 v-659h-310v659q0 89 -35 125t-103 36q-42 0 -79.5 -19t-70.5 -51v-750h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    d: "M120 0v1037h192q29 0 48.5 -13t27.5 -39l18 -60q30 28 62 52t68.5 40.5t79 26t92.5 9.5q85 0 150.5 -29.5t110.5 -82t68 -125t23 -157.5v-659h-310v659q0 76 -35 118.5t-103 42.5q-51 0 -96 -22t-86 -59v-739h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    d: "M582 1053q118 0 215 -37t166.5 -106t108 -167.5t38.5 -221.5q0 -124 -38.5 -223.5t-108 -169t-166.5 -107t-215 -37.5q-119 0 -216.5 37.5t-168 107t-109 169t-38.5 223.5q0 123 38.5 221.5t109 167.5t168 106t216.5 37zM582 214q107 0 157.5 75.5t50.5 229.5t-50.5 229 t-157.5 75q-110 0 -161 -75t-51 -229t51 -229.5t161 -75.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 1156,
    d: "M120 -329v1366h192q29 0 48.5 -13t27.5 -39l23 -76q30 33 64.5 60t74 46.5t85 30.5t99.5 11q81 0 150 -36t119 -104t78.5 -166.5t28.5 -223.5q0 -117 -32.5 -216t-91 -172t-140 -114t-180.5 -41q-81 0 -136 23t-100 62v-398h-310zM626 820q-34 0 -61.5 -6.5t-51 -18.5 t-43.5 -30.5t-40 -42.5v-440q35 -39 76 -54.5t86 -15.5q43 0 79 17t62.5 54.5t41.5 97.5t15 146q0 82 -12 138t-33.5 90.5t-51.5 49.5t-67 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    d: "M1040 1037v-1366h-310v442q-59 -58 -132 -93.5t-172 -35.5q-81 0 -150 36t-119 104t-78.5 166.5t-28.5 224.5q0 116 32 215.5t90.5 172t140.5 113.5t181 41q47 0 85 -8t69.5 -23t58.5 -36t52 -46l13 41q18 52 76 52h192zM534 222q34 0 61.5 6.5t50.5 18.5t43.5 30 t40.5 42v440q-36 38 -76.5 54t-85.5 16q-43 0 -79 -17t-62.5 -54.5t-41.5 -97.5t-15 -145q0 -82 12 -138t33.5 -90.5t51.5 -49.5t67 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 826,
    d: "M120 0v1037h184q23 0 38.5 -4t26 -12.5t16 -22.5t9.5 -34l17 -97q57 88 128 139t155 51q71 0 114 -34l-40 -228q-4 -21 -16 -29.5t-32 -8.5q-17 0 -40 4.5t-58 4.5q-122 0 -192 -130v-636h-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 880,
    d: "M754 810q-12 -19 -25.5 -27t-34.5 -8q-22 0 -44 9.5t-47.5 20.5t-57.5 20.5t-73 9.5q-59 0 -90.5 -22.5t-31.5 -62.5q0 -29 20.5 -48t54.5 -33.5t77 -27.5t88 -29t88 -37.5t77 -53t54.5 -76.5t20.5 -108q0 -77 -28 -142t-83.5 -112t-137 -73t-187.5 -26q-53 0 -106 10 t-102.5 27t-91.5 40.5t-72 50.5l72 114q13 20 31 31.5t47 11.5q27 0 48.5 -12t46.5 -26t58.5 -26t84.5 -12q36 0 61 7.5t40 20.5t22 29t7 33q0 31 -21 51t-55 34.5t-77.5 27t-88.5 28.5t-88.5 38.5t-77.5 57t-55 84.5t-21 121q0 66 25.5 125.5t76.5 104.5t128 71.5t180 26.5 q56 0 108.5 -10t98.5 -28t84 -42.5t67 -53.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 800,
    d: "M484 -16q-74 0 -130.5 21.5t-95 61t-58.5 95.5t-20 125v536h-88q-24 0 -41 15.5t-17 45.5v121l165 32l61 253q12 48 68 48h162v-303h252v-212h-252v-515q0 -36 17.5 -59.5t50.5 -23.5q17 0 28.5 3.5t20 8t16 8t17.5 3.5q14 0 22.5 -6.5t17.5 -20.5l94 -147 q-60 -45 -135 -67.5t-155 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    d: "M410 1037v-658q0 -77 35 -119t103 -42q51 0 95.5 21t86.5 59v739h310v-1037h-192q-58 0 -76 52l-19 60q-30 -29 -62 -52.5t-68.5 -40t-78.5 -26t-92 -9.5q-85 0 -150.5 29.5t-110.5 82.5t-68 125t-23 158v658h310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 1106,
    d: "M694 0h-282l-402 1037h258q33 0 55.5 -15.5t30.5 -38.5l144 -465q17 -57 32.5 -111t26.5 -108q11 54 27 108t34 111l150 465q8 23 30 38.5t52 15.5h246z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 1626,
    d: "M0 1037h248q33 0 57 -15t29 -39l104 -465q12 -53 22 -103t18 -99q14 49 29.5 98.5t30.5 103.5l130 466q6 23 29 38.5t53 15.5h138q33 0 56.5 -15.5t29.5 -38.5l124 -466q14 -53 28.5 -103t27.5 -101q8 50 19.5 99.5t24.5 104.5l110 465q5 24 28.5 39t53.5 15h236 l-322 -1037h-252q-20 0 -34 12t-22 40l-148 517q-10 35 -19 69t-16 68q-7 -35 -15.5 -69.5t-19.5 -69.5l-150 -515q-15 -52 -66 -52h-240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 1146,
    d: "M368 536l-334 501h298q33 0 48.5 -8.5t27.5 -28.5l185 -307q6 18 15 35t20 36l132 231q13 23 29 32.5t39 9.5h284l-334 -487l348 -550h-298q-33 0 -53 16t-33 38l-185 318q-5 -17 -12 -32t-15 -28l-152 -258q-12 -21 -32 -37.5t-50 -16.5h-276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 1106,
    d: "M544 -269q-14 -31 -34 -45.5t-64 -14.5h-232l200 420l-414 946h274q36 0 56 -16t28 -38l170 -447q24 -62 39 -124q10 32 22 63t23 63l154 445q8 23 31.5 38.5t50.5 15.5h250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 954,
    d: "M894 913q0 -32 -12 -61t-28 -50l-433 -572h463v-230h-820v126q0 19 10.5 47.5t29.5 54.5l437 579h-449v230h802v-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 600,
    d: "M120 397q0 60 -23 96.5t-83 36.5v173q30 0 50.5 10t32.5 27.5t17.5 42t5.5 53.5q0 44 -5.5 89t-12.5 90t-12.5 91t-5.5 92q0 81 23.5 147.5t73 113.5t125.5 72.5t182 25.5h52v-134q0 -16 -7 -27t-17 -18t-21 -10.5t-19 -3.5q-63 0 -92.5 -39t-29.5 -108q0 -55 4.5 -104 t9.5 -94.5t9.5 -89.5t4.5 -89q0 -38 -10 -73t-30.5 -64.5t-50.5 -52t-69 -34.5q39 -12 69 -34t50.5 -51.5t30.5 -65t10 -72.5q0 -45 -4.5 -89t-9.5 -89.5t-9.5 -94.5t-4.5 -104q0 -69 29.5 -108t92.5 -39q8 0 19 -3.5t21 -10.5t17 -18t7 -27v-134h-52q-106 0 -182 25.5 t-125.5 73t-73 113.5t-23.5 147q0 46 5.5 92t12.5 91t12.5 90t5.5 89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 600,
    d: "M180 1557h240v-1886h-240v1886z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 600,
    d: "M480 397q0 -44 5.5 -89t12.5 -90t12.5 -91t5.5 -92q0 -81 -23.5 -147t-73 -113.5t-125.5 -73t-182 -25.5h-52v134q0 16 7 27t17 18t21 10.5t19 3.5q63 0 92.5 39t29.5 108q0 55 -4.5 104t-9.5 94.5t-9.5 89.5t-4.5 89q0 37 10 72.5t30.5 65t50 51.5t68.5 34 q-39 12 -68.5 34.5t-50 52t-30.5 64.5t-10 73q0 45 4.5 89t9.5 89.5t9.5 94.5t4.5 104q0 69 -29.5 108t-92.5 39q-8 0 -19 3.5t-21 10.5t-17 18t-7 27v134h52q106 0 182 -25.5t125.5 -72.5t73 -113.5t23.5 -147.5q0 -46 -5.5 -92t-12.5 -91t-12.5 -90t-5.5 -89 q0 -29 5.5 -53.5t17.5 -42t32.5 -27.5t50.5 -10v-173q-60 0 -83 -36.5t-23 -96.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    d: "M730 677q48 0 74 31t26 91h250q0 -85 -22.5 -153t-64.5 -115.5t-103.5 -73t-139.5 -25.5q-53 0 -99.5 11.5t-86.5 26t-73.5 26t-60.5 11.5q-48 0 -74 -31t-26 -91h-250q0 85 22.5 153t64.5 115.5t103.5 73t139.5 25.5q53 0 99.5 -11.5t86.5 -26t73.5 -26t60.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 386
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 752,
    d: "M234 -329v527q0 92 11 183t29 184h210q18 -93 29 -184t11 -183v-527h-290zM200 882q0 36 13.5 67.5t37 54.5t55.5 36t70 13q37 0 69 -13t56 -36t37.5 -54.5t13.5 -67.5t-13.5 -67t-37.5 -54t-56 -36.5t-69 -13.5q-38 0 -70 13.5t-55.5 36.5t-37 54t-13.5 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    d: "M518 -6q-86 16 -161 58t-130.5 109t-87 157t-31.5 201q0 108 33.5 202.5t99.5 165.5t162.5 114t222.5 49l14 140q3 27 25 50t57 23h114l-23 -227q75 -17 138 -51t117 -85l-80 -105q-13 -17 -25.5 -26t-36.5 -9q-15 0 -29 5t-30 12.5t-35 16t-42 16.5l-61 -598 q43 6 72 19.5t51.5 27t41.5 23.5t42 10q18 0 32.5 -7t23.5 -18l86 -107q-40 -44 -84.5 -74.5t-91.5 -51t-96.5 -31.5t-99.5 -15l-12 -126q-3 -27 -25 -50t-57 -23h-114zM414 519q0 -108 33 -179t96 -104l59 584q-98 -20 -143 -98t-45 -203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    d: "M28 685q0 40 25.5 69.5t76.5 29.5h84v216q0 95 29 180.5t88.5 150.5t149 103.5t211.5 38.5q81 0 146.5 -20.5t117 -57t90.5 -86t68 -106.5l-124 -78q-37 -20 -71 -20q-46 0 -83 38q-38 39 -69 58t-75 19q-81 0 -120.5 -56.5t-39.5 -162.5v-217h380v-118q0 -15 -6.5 -28.5 t-18 -24.5t-27 -17.5t-34.5 -6.5h-294v-156q0 -60 -22.5 -108.5t-60.5 -90.5q45 10 90 15.5t91 5.5h502v-127q0 -22 -9.5 -45t-26.5 -41.5t-41.5 -30t-54.5 -11.5h-954v186q33 6 63.5 19t53.5 33t37 48t14 65v238h-186v96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    d: "M200 674q0 49 11.5 94t32.5 85l-154 153l156 148l150 -148q41 22 87 34t97 12q48 0 92.5 -11.5t84.5 -32.5l153 152l154 -150l-153 -151q23 -41 36 -87.5t13 -97.5q0 -49 -11.5 -94t-33.5 -85l155 -152l-156 -149l-151 148q-41 -22 -87 -34t-96 -12q-48 0 -92.5 11 t-84.5 31l-153 -150l-154 150l152 150q-23 41 -35.5 88t-12.5 98zM428 674q0 -32 12 -61t32.5 -51t48 -34.5t59.5 -12.5t60 12.5t49 34.5t33 51t12 61q0 34 -12 63t-33 51t-49 34.5t-60 12.5t-59.5 -12.5t-48 -34.5t-32.5 -51t-12 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    d: "M122 639h248l-390 818h258q44 0 71 -19.5t41 -53.5l166 -425q21 -54 37.5 -98.5t26.5 -88.5q9 45 24.5 89.5t35.5 97.5l164 425q11 29 39.5 51t70.5 22h260l-391 -818h249v-165h-300v-88h300v-165h-300v-221h-310v221h-300v165h300v88h-300v165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 600,
    d: "M180 1557h240v-819h-240v819zM180 490h240v-819h-240v819z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 1014,
    d: "M834 1228q-12 -19 -25.5 -26.5t-34.5 -7.5q-22 0 -44 9t-47.5 20.5t-57.5 20.5t-73 9q-72 0 -107 -27t-35 -69q0 -26 23 -47t61 -40t86.5 -38t99.5 -41t99.5 -49t86.5 -62.5t61 -81.5t23 -105q0 -80 -37 -146.5t-119 -108.5q43 -37 69.5 -85.5t26.5 -116.5 q0 -77 -28 -142t-83.5 -112t-137 -73t-187.5 -26q-53 0 -106 10t-102.5 27t-91.5 40.5t-72 50.5l72 114q13 20 31 31.5t47 11.5q27 0 48.5 -12t48 -26t62 -26t91.5 -12q65 0 101.5 23.5t36.5 70.5q0 37 -23.5 62.5t-61.5 45.5t-87 37t-100 37t-100 45t-87 60.5t-61.5 84.5 t-23.5 117q0 78 39 141t119 101q-44 40 -71 94t-27 132q0 66 25.5 125.5t76.5 104.5t128 71.5t180 26.5q56 0 108.5 -10t98.5 -28t84 -42.5t67 -53.5zM350 724q0 -35 24 -61t63 -47.5t89 -41t102 -41.5q28 17 40 41t12 51q0 36 -24 61.5t-63 46.5t-88.5 40t-100.5 42 q-29 -19 -41.5 -40.5t-12.5 -50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 660,
    d: "M298 1295q0 -32 -13 -60t-35.5 -48.5t-52 -32.5t-63.5 -12q-32 0 -60.5 12t-50 32.5t-34.5 48.5t-13 60q0 33 13 62t34.5 50.5t50 34t60.5 12.5q34 0 63.5 -12.5t52 -34t35.5 -50.5t13 -62zM684 1295q0 -32 -12.5 -60t-34.5 -48.5t-51.5 -32.5t-63.5 -12q-33 0 -62 12 t-51 32.5t-34.5 48.5t-12.5 60q0 33 12.5 62t34.5 50.5t51 34t62 12.5q34 0 63.5 -12.5t51.5 -34t34.5 -50.5t12.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 1570,
    d: "M984 542q12 0 23 -6t19 -15l102 -105q-54 -75 -141.5 -113.5t-202.5 -38.5q-101 0 -182.5 36.5t-138.5 100t-88 148.5t-31 183q0 102 36 187.5t98.5 148t146.5 97t181 34.5q115 0 198 -40t134 -100l-82 -109q-8 -8 -20 -18.5t-32 -10.5t-34.5 9t-32.5 20t-44.5 20 t-70.5 9q-101 0 -152.5 -66.5t-51.5 -180.5q0 -60 13.5 -106t37.5 -77t57.5 -47t73.5 -16q47 0 74.5 8.5t45.5 18.5t31 19t33 10zM40 729q0 103 26.5 198t75 177.5t116.5 150.5t151 116.5t177.5 75t197.5 26.5t198.5 -26.5t178 -75t151 -116.5t117 -150.5t75 -177.5 t26.5 -198q0 -102 -26.5 -197t-75 -177.5t-117 -150.5t-151 -116.5t-178 -75t-198.5 -26.5q-102 0 -197 26.5t-178 75t-151 116.5t-116.5 150.5t-75 177t-26.5 197.5zM206 729q0 -127 44.5 -237t122.5 -191.5t183.5 -128t227.5 -46.5q123 0 229.5 46.5t185.5 128t124 191.5 t45 237q0 85 -20.5 163t-58 145.5t-90.5 123t-118 94.5t-140 60.5t-157 21.5q-122 0 -227.5 -47t-183.5 -129.5t-122.5 -193.5t-44.5 -238z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 706,
    d: "M646 842h-104q-30 0 -45.5 8t-28.5 34l-12 27q-23 -20 -44 -34t-43.5 -24t-48 -14.5t-56.5 -4.5q-91 0 -142.5 46t-51.5 130q0 32 15.5 66.5t55.5 64t110 49.5t179 23v16q0 46 -19.5 62.5t-52.5 16.5q-30 0 -49 -6t-34.5 -13t-31.5 -13t-41 -6q-23 0 -38 13t-26 27 l-38 69q59 53 131 76.5t155 23.5q59 0 107 -19t82 -53t52.5 -79.5t18.5 -98.5v-387zM336 980q27 0 48.5 8.5t45.5 31.5v63q-47 -2 -76 -7.5t-45 -14t-21.5 -19.5t-5.5 -22q0 -23 12 -31.5t42 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 1012,
    d: "M110 525v39l262 402l102 -46q24 -11 35.5 -27t11.5 -36q0 -24 -15 -51l-120 -215q-17 -30 -36 -47q18 -16 36 -46l120 -216q15 -26 15 -50q0 -20 -11.5 -36t-35.5 -27l-102 -46zM470 525v39l262 402l102 -46q24 -11 35.5 -27t11.5 -36q0 -24 -15 -51l-120 -215 q-17 -30 -36 -47q18 -16 36 -46l120 -216q15 -26 15 -50q0 -20 -11.5 -36t-35.5 -27l-102 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    d: "M124 783h910v-501h-262v279h-648v222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 740,
    d: "M100 733h540v-250h-540v250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 1570,
    d: "M40 729q0 103 26.5 198t75 177.5t116.5 150.5t151 116.5t177.5 75t197.5 26.5t198.5 -26.5t178 -75t151 -116.5t117 -150.5t75 -177.5t26.5 -198q0 -102 -26.5 -197t-75 -177.5t-117 -150.5t-151 -116.5t-178 -75t-198.5 -26.5q-102 0 -197 26.5t-178 75t-151 116.5 t-116.5 150.5t-75 177t-26.5 197.5zM206 729q0 -127 44.5 -237t122.5 -191.5t183.5 -128t227.5 -46.5q115 0 215.5 41t178.5 114h-216q-55 0 -76 39l-92 231q-11 17 -23.5 24.5t-36.5 7.5h-32v-302h-268v901h352q100 0 172.5 -18t119 -52t68.5 -84t22 -114q0 -42 -10 -80.5 t-30.5 -71t-53 -58.5t-77.5 -43q29 -15 49 -38.5t36 -56.5l124 -257q76 81 119 188t43 232q0 85 -20.5 163t-58 145.5t-90.5 123t-118 94.5t-140 60.5t-157 21.5q-122 0 -227.5 -47t-183.5 -129.5t-122.5 -193.5t-44.5 -238zM702 767h64q48 0 75.5 7.5t41.5 21.5t17.5 35.5 t3.5 48.5q0 26 -3.5 45.5t-15.5 33t-35.5 20.5t-63.5 7h-84v-219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 660,
    d: "M20 1391h620v-190h-620v190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 810,
    d: "M40 1119q0 74 28 139t77 113t115.5 76t143.5 28t144 -28t116.5 -76t77.5 -113t28 -139q0 -72 -28 -136.5t-77.5 -112.5t-116.5 -76.5t-144 -28.5t-143.5 28.5t-115.5 76.5t-77 112.5t-28 136.5zM254 1117q0 -33 11 -61.5t31 -50t47.5 -33.5t60.5 -12t60.5 12t47.5 33.5 t31 50t11 61.5q0 34 -11 63.5t-31 51t-47.5 34t-60.5 12.5t-60.5 -12.5t-47.5 -34t-31 -51t-11 -63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    d: "M704 1272v-336h370v-223h-370v-319h-252v319h-368v223h368v336h252zM84 302h990v-222h-990v222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 668,
    d: "M352 1658q64 0 112.5 -18t81 -49t48.5 -71.5t16 -85.5q0 -41 -12.5 -75t-33 -65t-47.5 -60t-55 -59l-101 -103q33 10 65 16t58 6h68q35 0 54.5 -18.5t19.5 -49.5v-126h-570v69q0 20 8 43t28 42l198 194q20 20 37.5 43.5t30.5 47t20.5 46t7.5 41.5q0 24 -10 42.5t-36 18.5 q-21 0 -33.5 -10t-24.5 -32q-14 -20 -29 -31.5t-43 -11.5q-14 0 -30 3l-124 19q9 61 34 105t63.5 72.5t89 42.5t109.5 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 668,
    d: "M364 1658q62 0 109.5 -17.5t79 -46t47.5 -63.5t16 -70q0 -62 -23.5 -105.5t-78.5 -69.5q57 -19 85.5 -54t28.5 -92q0 -66 -24.5 -113t-63.5 -77t-88 -44t-98 -14q-52 0 -95.5 8.5t-79.5 32t-64.5 63.5t-50.5 103l96 38q25 9 48 9q47 0 64 -32q14 -26 33 -36t37 -10 q30 0 47 17.5t17 46.5q0 25 -5.5 40t-20 23t-39 10.5t-61.5 2.5v140q40 0 64.5 5t38 14t17.5 23t4 32q0 26 -10 43.5t-42 17.5q-24 0 -36.5 -9t-21.5 -27q-13 -23 -26.5 -34t-38.5 -11q-14 0 -33 3l-114 19q9 61 34 105t62 72.5t84.5 42.5t101.5 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 660,
    d: "M726 1473l-260 -263q-23 -23 -44 -32.5t-56 -9.5h-186l136 245q17 29 40 44.5t70 15.5h300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    d: "M410 1037v-666q0 -73 36 -113t102 -40q51 0 95.5 21t86.5 59v739h310v-1037h-192q-29 0 -48.5 13t-27.5 39l-19 61q-29 -26 -55 -43.5t-52.5 -28t-55 -15t-62.5 -4.5q-48 0 -89 13.5t-75 38.5q15 -46 20.5 -97.5t5.5 -96.5v-209h-154q-65 0 -100.5 32t-35.5 92v1242h310z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 1458,
    d: "M1432 1457v-251h-210v-1422h-270v1422h-196v-1422h-270v822q-104 0 -189.5 34t-146 91.5t-93.5 134t-33 162.5q0 94 33 173t93.5 136t146 88.5t189.5 31.5h946z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 570,
    d: "M60 596q0 45 17.5 85t48 69.5t71 46.5t87.5 17t88.5 -17t72 -46.5t48 -69.5t17.5 -85t-17.5 -84.5t-48 -69t-72 -46.5t-88.5 -17t-87.5 17t-71 46.5t-48 69t-17.5 84.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 660,
    d: "M194 -210q15 0 29 -4t35 -4q26 0 37 9.5t11 20.5q0 21 -30.5 31.5t-103.5 20.5l46 153h192l-17 -60q45 -12 75 -28t47.5 -35t25 -41.5t7.5 -46.5q0 -35 -19.5 -63t-54.5 -48t-84.5 -31t-109.5 -11q-41 0 -75.5 4t-72.5 12l28 94q6 27 34 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 668,
    d: "M150 1036h130v298l6 54l-50 -37q-20 -14 -42 -14q-18 0 -32.5 7.5t-21.5 16.5l-68 90l242 199h186v-614h102v-136h-452v136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 788,
    d: "M396 1477q75 0 138 -22t108 -63.5t70.5 -101t25.5 -134.5q0 -76 -25.5 -136.5t-70.5 -102.5t-108 -64.5t-138 -22.5q-76 0 -139.5 22.5t-109.5 64.5t-71.5 102.5t-25.5 136.5q0 75 25.5 134.5t71.5 101t109.5 63.5t139.5 22zM396 1004q51 0 75.5 34.5t24.5 115.5 t-24.5 115t-75.5 34q-56 0 -80 -34t-24 -115t24 -115.5t80 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 1012,
    d: "M280 123l-102 46q-24 11 -35.5 27t-11.5 36q0 24 15 50l120 216q15 28 36 46q-10 9 -19 21t-17 26l-120 215q-15 27 -15 51q0 20 11.5 36t35.5 27l102 46l262 -402v-39zM902 564v-39l-262 -402l-102 46q-24 11 -35.5 27t-11.5 36q0 24 15 50l120 216q15 28 36 46 q-10 9 -19 21t-17 26l-120 215q-15 27 -15 51q0 20 11.5 36t35.5 27l102 46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 1424,
    d: "M1342 295h80v-107q0 -15 -11 -27t-29 -12h-40v-149h-184v149h-274q-29 0 -45.5 12.5t-20.5 31.5l-18 92l328 465h214v-455zM130 844h130v298l6 54l-50 -37q-20 -14 -42 -14q-18 0 -32.5 7.5t-21.5 16.5l-68 90l242 199h186v-614h102v-136h-452v136zM1158 404q0 26 1.5 57 t5.5 64l-166 -230h159v109zM476 85q-16 -25 -32.5 -41.5t-35 -26t-39.5 -13.5t-45 -4h-132l848 1359q30 47 68 72.5t92 25.5h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 1424,
    d: "M1128 758q64 0 112.5 -18t81 -49t48.5 -71.5t16 -85.5q0 -41 -12.5 -75t-33 -65t-47.5 -60t-55 -59l-101 -103q33 10 65 16t58 6h68q35 0 54.5 -18.5t19.5 -49.5v-126h-570v69q0 20 8 43t28 42l198 194q20 20 37.5 43.5t30.5 47t20.5 46t7.5 41.5q0 24 -10 42.5t-36 18.5 q-21 0 -33.5 -10t-24.5 -32q-14 -20 -29 -31.5t-43 -11.5q-14 0 -30 3l-124 19q9 61 34 105t63.5 72.5t89 42.5t109.5 14zM130 844h130v298l6 54l-50 -37q-20 -14 -42 -14q-18 0 -32.5 7.5t-21.5 16.5l-68 90l242 199h186v-614h102v-136h-452v136zM438 85 q-16 -25 -32.5 -41.5t-35 -26t-39.5 -13.5t-45 -4h-132l848 1359q30 47 68 72.5t92 25.5h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 1424,
    d: "M1342 295h80v-107q0 -15 -11 -27t-29 -12h-40v-149h-184v149h-274q-29 0 -45.5 12.5t-20.5 31.5l-18 92l328 465h214v-455zM344 1466q62 0 109.5 -17.5t79 -46t47.5 -63.5t16 -70q0 -62 -23.5 -105.5t-78.5 -69.5q57 -19 85.5 -54t28.5 -92q0 -66 -24.5 -113t-63.5 -77 t-88 -44t-98 -14q-52 0 -95.5 8.5t-79.5 32t-64.5 63.5t-50.5 103l96 38q25 9 48 9q47 0 64 -32q14 -26 33 -36t37 -10q30 0 47 17.5t17 46.5q0 25 -5.5 40t-20 23t-39 10.5t-61.5 2.5v140q40 0 64.5 5t38 14t17.5 23t4 32q0 26 -10 43.5t-42 17.5q-24 0 -36.5 -9t-21.5 -27 q-13 -23 -26.5 -34t-38.5 -11q-14 0 -33 3l-114 19q9 61 34 105t62 72.5t84.5 42.5t101.5 14zM1158 404q0 26 1.5 57t5.5 64l-166 -230h159v109zM476 85q-16 -25 -32.5 -41.5t-35 -26t-39.5 -13.5t-45 -4h-132l848 1359q30 47 68 72.5t92 25.5h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 882,
    d: "M864 -196q-38 -31 -81 -58t-93 -47.5t-107.5 -32t-124.5 -11.5q-94 0 -169.5 24t-128.5 68.5t-81.5 108.5t-28.5 144q0 76 21 129t53.5 89.5t71 62t73 47t60 44t31.5 54.5l28 139h212l22 -160q1 -9 1.5 -15.5t0.5 -12.5q0 -46 -21 -77t-53 -54t-69 -42.5t-69 -43t-53 -55 t-21 -78.5q0 -60 39.5 -95.5t108.5 -35.5q52 0 88 11t61.5 24.5t44.5 24.5t38 11q43 0 64 -37zM324 883q0 36 13.5 67t37 54t55.5 36.5t70 13.5q37 0 69 -13.5t56 -36.5t37.5 -54t13.5 -67t-13.5 -67.5t-37.5 -54.5t-56 -36t-69 -13q-38 0 -70 13t-55.5 36t-37 54.5 t-13.5 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 1474,
    d: "M1476 0h-262q-44 0 -72.5 20.5t-39.5 52.5l-86 254h-554l-86 -254q-10 -28 -39 -50.5t-71 -22.5h-264l564 1457h346zM540 557h398l-134 399q-13 38 -30.5 89.5t-34.5 111.5q-16 -61 -33 -113t-32 -90zM612 1798q23 0 40.5 -2.5t31 -8t25.5 -15t25 -23.5l182 -198h-246 q-18 0 -31 1t-24.5 4.5t-22 9t-22.5 14.5l-300 218h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 1474,
    d: "M1476 0h-262q-44 0 -72.5 20.5t-39.5 52.5l-86 254h-554l-86 -254q-10 -28 -39 -50.5t-71 -22.5h-264l564 1457h346zM540 557h398l-134 399q-13 38 -30.5 89.5t-34.5 111.5q-16 -61 -33 -113t-32 -90zM1162 1798l-295 -214q-26 -20 -48.5 -26.5t-56.5 -6.5h-246l181 197 q13 15 25.5 24.5t26.5 15.5t31 8t40 2h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 1474,
    d: "M1476 0h-262q-44 0 -72.5 20.5t-39.5 52.5l-86 254h-554l-86 -254q-10 -28 -39 -50.5t-71 -22.5h-264l564 1457h346zM540 557h398l-134 399q-13 38 -30.5 89.5t-34.5 111.5q-16 -61 -33 -113t-32 -90zM1138 1551h-234q-18 0 -39 5t-35 13l-74 45q-5 2 -9 5t-9 6 q-5 -3 -9 -6t-9 -5l-74 -45q-14 -8 -35 -13t-39 -5h-234l244 227h312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 1474,
    d: "M1476 0h-262q-44 0 -72.5 20.5t-39.5 52.5l-86 254h-554l-86 -254q-10 -28 -39 -50.5t-71 -22.5h-264l564 1457h346zM540 557h398l-134 399q-13 38 -30.5 89.5t-34.5 111.5q-16 -61 -33 -113t-32 -90zM862 1729q21 0 35.5 11t14.5 40h168q0 -55 -14.5 -100t-41.5 -77.5 t-66 -50t-88 -17.5q-37 0 -72.5 9t-67 20.5t-57.5 20.5t-45 9q-21 0 -34.5 -12.5t-13.5 -40.5h-170q0 55 15 100t42 77.5t66 50.5t87 18q37 0 72.5 -9t67 -20t57.5 -20t45 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 1474,
    d: "M1476 0h-262q-44 0 -72.5 20.5t-39.5 52.5l-86 254h-554l-86 -254q-10 -28 -39 -50.5t-71 -22.5h-264l564 1457h346zM540 557h398l-134 399q-13 38 -30.5 89.5t-34.5 111.5q-16 -61 -33 -113t-32 -90zM674 1668q0 -32 -12.5 -59t-34.5 -47.5t-51 -32t-62 -11.5 q-30 0 -57.5 11.5t-48.5 32t-33.5 47.5t-12.5 59q0 31 12.5 59t33.5 49t48.5 33t57.5 12q33 0 62 -12t51 -33t34.5 -49t12.5 -59zM1114 1668q0 -32 -12.5 -59t-33.5 -47.5t-49.5 -32t-60.5 -11.5t-60.5 11.5t-49.5 32t-33.5 47.5t-12.5 59q0 31 12.5 59t33.5 49t49.5 33 t60.5 12t60.5 -12t49.5 -33t33.5 -49t12.5 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 1474,
    d: "M1476 0h-262q-44 0 -72.5 20.5t-39.5 52.5l-86 254h-554l-86 -254q-10 -28 -39 -50.5t-71 -22.5h-264l564 1457h346zM540 557h398l-134 399q-13 38 -30.5 89.5t-34.5 111.5q-16 -61 -33 -113t-32 -90zM518 1701q0 46 18.5 83.5t49 64t70.5 41t84 14.5q46 0 87 -14.5 t72.5 -41t50 -64t18.5 -83.5q0 -44 -18.5 -80.5t-50 -62.5t-72.5 -40t-87 -14q-44 0 -84 14t-70.5 40t-49 62.5t-18.5 80.5zM664 1701q0 -35 19.5 -57.5t60.5 -22.5q36 0 57 22.5t21 57.5q0 38 -21 60t-57 22q-41 0 -60.5 -22t-19.5 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 1876,
    d: "M684 1457h1120v-260h-645l41 -340h464v-250h-434l42 -347h532v-260h-820l-40 327h-483l-111 -254q-14 -33 -47.5 -53t-78.5 -20h-256zM562 557h354l-78 652q-20 -59 -40 -110t-40 -94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 1314,
    d: "M622 -210q15 0 29 -4t35 -4q26 0 37 9.5t11 20.5q0 21 -30.5 31.5t-103.5 20.5l38 127q-142 18 -253.5 80.5t-189 159.5t-118.5 224t-41 274q0 163 56 299.5t156.5 235.5t240.5 154t309 55q82 0 154.5 -14.5t135.5 -40t116 -61t94 -78.5l-114 -153q-11 -14 -26 -25.5 t-42 -11.5q-18 0 -34 8t-34 19.5t-39.5 25t-51 25t-69 19.5t-92.5 8q-92 0 -168 -32.5t-130.5 -93t-85 -146.5t-30.5 -193q0 -112 30.5 -199t83 -146.5t122.5 -90.5t150 -31q46 0 84 4.5t70.5 15.5t62 28.5t59.5 43.5q12 10 26 16.5t29 6.5q12 0 24 -4.5t23 -15.5l134 -141 q-77 -101 -189.5 -158.5t-261.5 -69.5l-8 -31q45 -12 75 -28t47.5 -35t25 -41.5t7.5 -46.5q0 -35 -19.5 -63t-54.5 -48t-84.5 -31t-109.5 -11q-41 0 -75.5 4t-72.5 12l28 94q6 27 34 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 1130,
    d: "M1058 1457v-260h-598v-340h458v-250h-458v-347h598v-260h-938v1457h938zM480 1798q23 0 40.5 -2.5t31 -8t25.5 -15t25 -23.5l182 -198h-246q-18 0 -31 1t-24.5 4.5t-22 9t-22.5 14.5l-300 218h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 1130,
    d: "M1058 1457v-260h-598v-340h458v-250h-458v-347h598v-260h-938v1457h938zM1030 1798l-295 -214q-26 -20 -48.5 -26.5t-56.5 -6.5h-246l181 197q13 15 25.5 24.5t26.5 15.5t31 8t40 2h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 1130,
    d: "M1058 1457v-260h-598v-340h458v-250h-458v-347h598v-260h-938v1457h938zM1006 1551h-234q-18 0 -39 5t-35 13l-74 45q-5 2 -9 5t-9 6q-5 -3 -9 -6t-9 -5l-74 -45q-14 -8 -35 -13t-39 -5h-234l244 227h312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 1130,
    d: "M1058 1457v-260h-598v-340h458v-250h-458v-347h598v-260h-938v1457h938zM542 1668q0 -32 -12.5 -59t-34.5 -47.5t-51 -32t-62 -11.5q-30 0 -57.5 11.5t-48.5 32t-33.5 47.5t-12.5 59q0 31 12.5 59t33.5 49t48.5 33t57.5 12q33 0 62 -12t51 -33t34.5 -49t12.5 -59z M982 1668q0 -32 -12.5 -59t-33.5 -47.5t-49.5 -32t-60.5 -11.5t-60.5 11.5t-49.5 32t-33.5 47.5t-12.5 59q0 31 12.5 59t33.5 49t49.5 33t60.5 12t60.5 -12t49.5 -33t33.5 -49t12.5 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 640,
    d: "M490 0h-340v1457h340v-1457zM199 1798q23 0 40.5 -2.5t31 -8t25.5 -15t25 -23.5l182 -198h-246q-18 0 -31 1t-24.5 4.5t-22 9t-22.5 14.5l-300 218h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 640,
    d: "M490 0h-340v1457h340v-1457zM749 1798l-295 -214q-26 -20 -48.5 -26.5t-56.5 -6.5h-246l181 197q13 15 25.5 24.5t26.5 15.5t31 8t40 2h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 640,
    d: "M490 0h-340v1457h340v-1457zM725 1551h-234q-18 0 -39 5t-35 13l-74 45q-5 2 -9 5t-9 6q-5 -3 -9 -6t-9 -5l-74 -45q-14 -8 -35 -13t-39 -5h-234l244 227h312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 640,
    d: "M490 0h-340v1457h340v-1457zM261 1668q0 -32 -12.5 -59t-34.5 -47.5t-51 -32t-62 -11.5q-30 0 -57.5 11.5t-48.5 32t-33.5 47.5t-12.5 59q0 31 12.5 59t33.5 49t48.5 33t57.5 12q33 0 62 -12t51 -33t34.5 -49t12.5 -59zM701 1668q0 -32 -12.5 -59t-33.5 -47.5t-49.5 -32 t-60.5 -11.5t-60.5 11.5t-49.5 32t-33.5 47.5t-12.5 59q0 31 12.5 59t33.5 49t49.5 33t60.5 12t60.5 -12t49.5 -33t33.5 -49t12.5 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 1584,
    d: "M54 823h166v634h566q170 0 309.5 -55t238.5 -152t153.5 -230.5t54.5 -290.5q0 -158 -54.5 -291.5t-153.5 -231t-238.5 -152t-309.5 -54.5h-566v639h-166v184zM1196 729q0 108 -28 195t-80.5 147.5t-128.5 93t-173 32.5h-226v-374h344v-184h-344v-379h226q97 0 173 32.5 t128.5 93t80.5 147.5t28 196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 1512,
    d: "M298 1457q22 0 37 -2t27 -7.5t23 -15.5t25 -27l692 -875q-4 42 -6 81.5t-2 74.5v771h298v-1457h-176q-39 0 -66 12t-52 44l-687 868q3 -38 5 -74.5t2 -68.5v-781h-298v1457h178v0zM888 1729q21 0 35.5 11t14.5 40h168q0 -55 -14.5 -100t-41.5 -77.5t-66 -50t-88 -17.5 q-37 0 -72.5 9t-67 20.5t-57.5 20.5t-45 9q-21 0 -34.5 -12.5t-13.5 -40.5h-170q0 55 15 100t42 77.5t66 50.5t87 18q37 0 72.5 -9t67 -20t57.5 -20t45 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 1600,
    d: "M1558 729q0 -158 -54.5 -294t-153.5 -236.5t-238.5 -157.5t-309.5 -57t-310 57t-239.5 157.5t-154 236.5t-54.5 294t54.5 294t154 236t239.5 157t310 57t309.5 -57.5t238.5 -157.5t153.5 -236t54.5 -293zM1212 729q0 108 -28 194.5t-80.5 146.5t-128.5 92t-173 32 q-98 0 -174.5 -32t-129 -92t-80.5 -146.5t-28 -194.5q0 -109 28 -195.5t80.5 -146.5t129 -91.5t174.5 -31.5q97 0 173 31.5t128.5 91.5t80.5 146.5t28 195.5zM678 1798q23 0 40.5 -2.5t31 -8t25.5 -15t25 -23.5l182 -198h-246q-18 0 -31 1t-24.5 4.5t-22 9t-22.5 14.5 l-300 218h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 1600,
    d: "M1558 729q0 -158 -54.5 -294t-153.5 -236.5t-238.5 -157.5t-309.5 -57t-310 57t-239.5 157.5t-154 236.5t-54.5 294t54.5 294t154 236t239.5 157t310 57t309.5 -57.5t238.5 -157.5t153.5 -236t54.5 -293zM1212 729q0 108 -28 194.5t-80.5 146.5t-128.5 92t-173 32 q-98 0 -174.5 -32t-129 -92t-80.5 -146.5t-28 -194.5q0 -109 28 -195.5t80.5 -146.5t129 -91.5t174.5 -31.5q97 0 173 31.5t128.5 91.5t80.5 146.5t28 195.5zM1228 1798l-295 -214q-26 -20 -48.5 -26.5t-56.5 -6.5h-246l181 197q13 15 25.5 24.5t26.5 15.5t31 8t40 2h342z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 1600,
    d: "M1558 729q0 -158 -54.5 -294t-153.5 -236.5t-238.5 -157.5t-309.5 -57t-310 57t-239.5 157.5t-154 236.5t-54.5 294t54.5 294t154 236t239.5 157t310 57t309.5 -57.5t238.5 -157.5t153.5 -236t54.5 -293zM1212 729q0 108 -28 194.5t-80.5 146.5t-128.5 92t-173 32 q-98 0 -174.5 -32t-129 -92t-80.5 -146.5t-28 -194.5q0 -109 28 -195.5t80.5 -146.5t129 -91.5t174.5 -31.5q97 0 173 31.5t128.5 91.5t80.5 146.5t28 195.5zM1204 1551h-234q-18 0 -39 5t-35 13l-74 45q-5 2 -9 5t-9 6q-5 -3 -9 -6t-9 -5l-74 -45q-14 -8 -35 -13t-39 -5 h-234l244 227h312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 1600,
    d: "M1558 729q0 -158 -54.5 -294t-153.5 -236.5t-238.5 -157.5t-309.5 -57t-310 57t-239.5 157.5t-154 236.5t-54.5 294t54.5 294t154 236t239.5 157t310 57t309.5 -57.5t238.5 -157.5t153.5 -236t54.5 -293zM1212 729q0 108 -28 194.5t-80.5 146.5t-128.5 92t-173 32 q-98 0 -174.5 -32t-129 -92t-80.5 -146.5t-28 -194.5q0 -109 28 -195.5t80.5 -146.5t129 -91.5t174.5 -31.5q97 0 173 31.5t128.5 91.5t80.5 146.5t28 195.5zM928 1729q21 0 35.5 11t14.5 40h168q0 -55 -14.5 -100t-41.5 -77.5t-66 -50t-88 -17.5q-37 0 -72.5 9t-67 20.5 t-57.5 20.5t-45 9q-21 0 -34.5 -12.5t-13.5 -40.5h-170q0 55 15 100t42 77.5t66 50.5t87 18q37 0 72.5 -9t67 -20t57.5 -20t45 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 1600,
    d: "M1558 729q0 -158 -54.5 -294t-153.5 -236.5t-238.5 -157.5t-309.5 -57t-310 57t-239.5 157.5t-154 236.5t-54.5 294t54.5 294t154 236t239.5 157t310 57t309.5 -57.5t238.5 -157.5t153.5 -236t54.5 -293zM1212 729q0 108 -28 194.5t-80.5 146.5t-128.5 92t-173 32 q-98 0 -174.5 -32t-129 -92t-80.5 -146.5t-28 -194.5q0 -109 28 -195.5t80.5 -146.5t129 -91.5t174.5 -31.5q97 0 173 31.5t128.5 91.5t80.5 146.5t28 195.5zM740 1668q0 -32 -12.5 -59t-34.5 -47.5t-51 -32t-62 -11.5q-30 0 -57.5 11.5t-48.5 32t-33.5 47.5t-12.5 59 q0 31 12.5 59t33.5 49t48.5 33t57.5 12q33 0 62 -12t51 -33t34.5 -49t12.5 -59zM1180 1668q0 -32 -12.5 -59t-33.5 -47.5t-49.5 -32t-60.5 -11.5t-60.5 11.5t-49.5 32t-33.5 47.5t-12.5 59q0 31 12.5 59t33.5 49t49.5 33t60.5 12t60.5 -12t49.5 -33t33.5 -49t12.5 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    d: "M1048 982l-310 -310l330 -329l-164 -157l-326 326l-328 -328l-164 157l331 331l-311 312l162 157l309 -309l307 307z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 1600,
    d: "M1558 729q0 -158 -54.5 -294t-153.5 -236.5t-238.5 -157.5t-309.5 -57q-94 0 -178 17.5t-159 50.5l-57 -79q-17 -24 -39 -40.5t-46 -26.5t-49.5 -14.5t-49.5 -4.5h-132l199 276q-118 102 -182.5 247t-64.5 319q0 158 54.5 294t154 236t239.5 157t310 57q105 0 197.5 -22 t173.5 -64l41 57q16 22 29.5 37t28.5 24.5t34 13.5t46 4h172l-184 -255q105 -102 161.5 -240t56.5 -299zM390 729q0 -192 84 -311l527 731q-42 22 -92 33.5t-107 11.5q-98 0 -174.5 -32t-129 -92t-80.5 -146.5t-28 -194.5zM1212 729q0 81 -16 150t-46 124l-512 -711 q71 -28 164 -28q97 0 173 31.5t128.5 91.5t80.5 146.5t28 195.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 1452,
    d: "M726 267q68 0 121.5 22.5t90.5 64.5t56.5 102.5t19.5 137.5v863h338v-863q0 -134 -43.5 -246t-124.5 -193t-197 -126t-261 -45q-146 0 -262 45t-197 126t-124 193t-43 246v863h338v-862q0 -77 19.5 -137.5t56.5 -103t90.5 -65t121.5 -22.5zM600 1798q23 0 40.5 -2.5 t31 -8t25.5 -15t25 -23.5l182 -198h-246q-18 0 -31 1t-24.5 4.5t-22 9t-22.5 14.5l-300 218h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 1452,
    d: "M726 267q68 0 121.5 22.5t90.5 64.5t56.5 102.5t19.5 137.5v863h338v-863q0 -134 -43.5 -246t-124.5 -193t-197 -126t-261 -45q-146 0 -262 45t-197 126t-124 193t-43 246v863h338v-862q0 -77 19.5 -137.5t56.5 -103t90.5 -65t121.5 -22.5zM1150 1798l-295 -214 q-26 -20 -48.5 -26.5t-56.5 -6.5h-246l181 197q13 15 25.5 24.5t26.5 15.5t31 8t40 2h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 1452,
    d: "M726 267q68 0 121.5 22.5t90.5 64.5t56.5 102.5t19.5 137.5v863h338v-863q0 -134 -43.5 -246t-124.5 -193t-197 -126t-261 -45q-146 0 -262 45t-197 126t-124 193t-43 246v863h338v-862q0 -77 19.5 -137.5t56.5 -103t90.5 -65t121.5 -22.5zM1126 1551h-234q-18 0 -39 5 t-35 13l-74 45q-5 2 -9 5t-9 6q-5 -3 -9 -6t-9 -5l-74 -45q-14 -8 -35 -13t-39 -5h-234l244 227h312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 1452,
    d: "M726 267q68 0 121.5 22.5t90.5 64.5t56.5 102.5t19.5 137.5v863h338v-863q0 -134 -43.5 -246t-124.5 -193t-197 -126t-261 -45q-146 0 -262 45t-197 126t-124 193t-43 246v863h338v-862q0 -77 19.5 -137.5t56.5 -103t90.5 -65t121.5 -22.5zM662 1668q0 -32 -12.5 -59 t-34.5 -47.5t-51 -32t-62 -11.5q-30 0 -57.5 11.5t-48.5 32t-33.5 47.5t-12.5 59q0 31 12.5 59t33.5 49t48.5 33t57.5 12q33 0 62 -12t51 -33t34.5 -49t12.5 -59zM1102 1668q0 -32 -12.5 -59t-33.5 -47.5t-49.5 -32t-60.5 -11.5t-60.5 11.5t-49.5 32t-33.5 47.5t-12.5 59 q0 31 12.5 59t33.5 49t49.5 33t60.5 12t60.5 -12t49.5 -33t33.5 -49t12.5 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 1354,
    d: "M846 554v-554h-338v554l-528 903h298q44 0 70 -20.5t42 -52.5l206 -424q25 -51 46 -94t37 -85q15 43 36 86t45 93l204 424q6 13 16.5 26t24 23.5t31 17t38.5 6.5h300zM1104 1798l-295 -214q-26 -20 -48.5 -26.5t-56.5 -6.5h-246l181 197q13 15 25.5 24.5t26.5 15.5t31 8 t40 2h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 1276,
    d: "M458 252v-252h-338v1457h338v-235h176q154 0 264.5 -36.5t182 -100.5t105.5 -151t34 -188q0 -109 -35 -200t-107 -156t-182.5 -101.5t-261.5 -36.5h-176zM458 507h176q132 0 190 63t58 176q0 50 -15 91t-45.5 70.5t-77 45.5t-110.5 16h-176v-462z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 1316,
    d: "M724 1485q130 0 220 -37t145.5 -92t80 -117t24.5 -113q0 -56 -18 -96t-45 -69t-58 -50.5t-58 -40.5t-45 -38.5t-18 -45.5q0 -28 23.5 -50.5t58 -46.5t75.5 -52t75.5 -67.5t58 -94t23.5 -130.5q0 -91 -34.5 -158.5t-91.5 -112.5t-132 -67.5t-156 -22.5q-44 0 -90 10 t-89.5 27t-82 40.5t-68.5 50.5l72 114q13 20 31 31.5t47 11.5q27 0 49 -12t44.5 -26t49.5 -26t65 -12q39 0 67.5 28.5t28.5 75.5q0 40 -26 68t-65 52t-84 48.5t-84 59t-65 82t-26 118.5q0 60 19.5 103t49.5 74.5t64 56.5t64 49t49.5 51.5t19.5 64.5q0 67 -43.5 105.5 t-138.5 38.5q-63 0 -107.5 -20.5t-72.5 -59t-41 -94.5t-13 -126v-968h-310v978q0 107 37.5 199.5t109.5 161t175.5 107.5t235.5 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 1078,
    d: "M836 0q-44 0 -66.5 12t-37.5 50l-22 57q-39 -33 -75 -58t-74.5 -42.5t-82 -26t-96.5 -8.5q-71 0 -129 18.5t-98.5 54.5t-62.5 89.5t-22 123.5q0 55 28 113t97 105.5t186 79.5t295 36v44q0 91 -37.5 131.5t-106.5 40.5q-55 0 -90 -12t-62.5 -27t-53.5 -27t-62 -12 q-32 0 -54.5 15.5t-35.5 38.5l-56 97q94 83 208.5 123.5t245.5 40.5q94 0 169.5 -30.5t128 -85t80.5 -129.5t28 -164v-648h-142zM480 189q60 0 105 21t91 68v144q-93 -4 -153 -16t-95 -30t-48.5 -41t-13.5 -50q0 -53 29 -74.5t85 -21.5zM484 1473q47 0 70 -15.5t40 -44.5 l136 -245h-176q-35 0 -56 9.5t-44 32.5l-260 263h290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 1078,
    d: "M836 0q-44 0 -66.5 12t-37.5 50l-22 57q-39 -33 -75 -58t-74.5 -42.5t-82 -26t-96.5 -8.5q-71 0 -129 18.5t-98.5 54.5t-62.5 89.5t-22 123.5q0 55 28 113t97 105.5t186 79.5t295 36v44q0 91 -37.5 131.5t-106.5 40.5q-55 0 -90 -12t-62.5 -27t-53.5 -27t-62 -12 q-32 0 -54.5 15.5t-35.5 38.5l-56 97q94 83 208.5 123.5t245.5 40.5q94 0 169.5 -30.5t128 -85t80.5 -129.5t28 -164v-648h-142zM480 189q60 0 105 21t91 68v144q-93 -4 -153 -16t-95 -30t-48.5 -41t-13.5 -50q0 -53 29 -74.5t85 -21.5zM958 1473l-260 -263 q-23 -23 -44 -32.5t-56 -9.5h-186l136 245q17 29 40 44.5t70 15.5h300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 1078,
    d: "M836 0q-44 0 -66.5 12t-37.5 50l-22 57q-39 -33 -75 -58t-74.5 -42.5t-82 -26t-96.5 -8.5q-71 0 -129 18.5t-98.5 54.5t-62.5 89.5t-22 123.5q0 55 28 113t97 105.5t186 79.5t295 36v44q0 91 -37.5 131.5t-106.5 40.5q-55 0 -90 -12t-62.5 -27t-53.5 -27t-62 -12 q-32 0 -54.5 15.5t-35.5 38.5l-56 97q94 83 208.5 123.5t245.5 40.5q94 0 169.5 -30.5t128 -85t80.5 -129.5t28 -164v-648h-142zM480 189q60 0 105 21t91 68v144q-93 -4 -153 -16t-95 -30t-48.5 -41t-13.5 -50q0 -53 29 -74.5t85 -21.5zM942 1168h-206q-18 0 -33 5.5 t-27 14.5l-84 72q-7 5 -13 11t-12 14q-6 -8 -12.5 -14t-12.5 -11l-86 -72q-9 -8 -25.5 -14t-34.5 -6h-214l234 289h292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 1078,
    d: "M836 0q-44 0 -66.5 12t-37.5 50l-22 57q-39 -33 -75 -58t-74.5 -42.5t-82 -26t-96.5 -8.5q-71 0 -129 18.5t-98.5 54.5t-62.5 89.5t-22 123.5q0 55 28 113t97 105.5t186 79.5t295 36v44q0 91 -37.5 131.5t-106.5 40.5q-55 0 -90 -12t-62.5 -27t-53.5 -27t-62 -12 q-32 0 -54.5 15.5t-35.5 38.5l-56 97q94 83 208.5 123.5t245.5 40.5q94 0 169.5 -30.5t128 -85t80.5 -129.5t28 -164v-648h-142zM480 189q60 0 105 21t91 68v144q-93 -4 -153 -16t-95 -30t-48.5 -41t-13.5 -50q0 -53 29 -74.5t85 -21.5zM666 1387q24 0 39 12.5t15 53.5h188 q0 -63 -17.5 -113.5t-48.5 -86t-73 -54.5t-91 -19q-37 0 -69 11.5t-59.5 25.5t-50 25.5t-39.5 11.5q-24 0 -38 -13.5t-14 -54.5h-190q0 63 18 113.5t49 86.5t73 55.5t90 19.5q37 0 69.5 -11.5t59.5 -25.5t49.5 -25.5t39.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 1078,
    d: "M836 0q-44 0 -66.5 12t-37.5 50l-22 57q-39 -33 -75 -58t-74.5 -42.5t-82 -26t-96.5 -8.5q-71 0 -129 18.5t-98.5 54.5t-62.5 89.5t-22 123.5q0 55 28 113t97 105.5t186 79.5t295 36v44q0 91 -37.5 131.5t-106.5 40.5q-55 0 -90 -12t-62.5 -27t-53.5 -27t-62 -12 q-32 0 -54.5 15.5t-35.5 38.5l-56 97q94 83 208.5 123.5t245.5 40.5q94 0 169.5 -30.5t128 -85t80.5 -129.5t28 -164v-648h-142zM480 189q60 0 105 21t91 68v144q-93 -4 -153 -16t-95 -30t-48.5 -41t-13.5 -50q0 -53 29 -74.5t85 -21.5zM530 1295q0 -32 -13 -60t-35.5 -48.5 t-52 -32.5t-63.5 -12q-32 0 -60.5 12t-50 32.5t-34.5 48.5t-13 60q0 33 13 62t34.5 50.5t50 34t60.5 12.5q34 0 63.5 -12.5t52 -34t35.5 -50.5t13 -62zM916 1295q0 -32 -12.5 -60t-34.5 -48.5t-51.5 -32.5t-63.5 -12q-33 0 -62 12t-51 32.5t-34.5 48.5t-12.5 60 q0 33 12.5 62t34.5 50.5t51 34t62 12.5q34 0 63.5 -12.5t51.5 -34t34.5 -50.5t12.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 1078,
    d: "M836 0q-44 0 -66.5 12t-37.5 50l-22 57q-39 -33 -75 -58t-74.5 -42.5t-82 -26t-96.5 -8.5q-71 0 -129 18.5t-98.5 54.5t-62.5 89.5t-22 123.5q0 55 28 113t97 105.5t186 79.5t295 36v44q0 91 -37.5 131.5t-106.5 40.5q-55 0 -90 -12t-62.5 -27t-53.5 -27t-62 -12 q-32 0 -54.5 15.5t-35.5 38.5l-56 97q94 83 208.5 123.5t245.5 40.5q94 0 169.5 -30.5t128 -85t80.5 -129.5t28 -164v-648h-142zM480 189q60 0 105 21t91 68v144q-93 -4 -153 -16t-95 -30t-48.5 -41t-13.5 -50q0 -53 29 -74.5t85 -21.5zM320 1334q0 50 20 90.5t53 69.5 t77 44.5t92 15.5q49 0 94 -15.5t79.5 -44.5t54.5 -69.5t20 -90.5q0 -49 -20 -88.5t-54.5 -67.5t-79.5 -43.5t-94 -15.5q-48 0 -92 15.5t-77 43.5t-53 67.5t-20 88.5zM486 1334q0 -35 19.5 -57.5t60.5 -22.5q36 0 57 22.5t21 57.5q0 38 -21 60t-57 22q-41 0 -60.5 -22 t-19.5 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 1668,
    d: "M1180 1053q92 0 171 -35t136.5 -99.5t90 -156t32.5 -204.5q0 -35 -3 -57t-10.5 -35t-20.5 -18t-34 -5h-570q17 -119 77.5 -173t152.5 -54q67 0 106.5 12t65 26t44 26t44.5 12q43 0 62 -27l84 -103q-48 -55 -102.5 -89.5t-111.5 -54t-113.5 -27t-108.5 -7.5 q-51 0 -101 10.5t-96 33t-86.5 57.5t-73.5 83q-32 -48 -76.5 -83t-97.5 -57.5t-113 -33t-124 -10.5q-160 0 -247 78t-87 219q0 37 12 76t39.5 76.5t73 71t113 59.5t158.5 42t210 19v23q0 91 -37.5 136t-106.5 45q-55 0 -90 -13.5t-62.5 -30t-53.5 -30t-62 -13.5 q-32 0 -54.5 15.5t-35.5 38.5l-56 97q94 83 196 123.5t224 40.5q113 0 188 -39t117 -108q59 66 143 104.5t194 38.5zM1166 839q-88 0 -135.5 -55.5t-60.5 -160.5h364q0 37 -8.5 75.5t-28 69.5t-52 51t-79.5 20zM676 443q-93 -5 -153 -18.5t-95 -33.5t-48.5 -44.5 t-13.5 -50.5q0 -54 29 -80.5t85 -26.5q42 0 78 12.5t62 40.5t41 73.5t15 111.5v16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 972,
    d: "M410 -210q15 0 29 -4t35 -4q26 0 37 9.5t11 20.5q0 21 -30.5 31.5t-103.5 20.5l39 131q-78 16 -146.5 59t-119.5 110t-80 156.5t-29 200.5q0 112 33.5 209.5t99 169t162 112.5t223.5 41q122 0 214 -39t166 -114l-82 -109q-14 -17 -27 -27t-37 -10q-23 0 -41.5 11 t-41.5 24.5t-54 24.5t-77 11q-57 0 -98.5 -21t-68.5 -60t-40 -95.5t-13 -127.5q0 -149 57.5 -229t158.5 -80q54 0 85.5 13.5t53.5 30t40.5 30.5t46.5 14q37 0 56 -27l90 -111q-38 -44 -79.5 -74.5t-85 -50.5t-87.5 -31.5t-88 -16.5l-9 -32q45 -12 75 -28t47.5 -35t25 -41.5 t7.5 -46.5q0 -35 -19.5 -63t-54.5 -48t-84.5 -31t-109.5 -11q-41 0 -75.5 4t-72.5 12l28 94q6 27 34 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 1088,
    d: "M564 1053q103 0 188.5 -32t147 -93t96 -149.5t34.5 -200.5q0 -35 -3 -57t-11 -35t-21.5 -18t-34.5 -5h-598q15 -130 79 -188.5t165 -58.5q54 0 93 13t69.5 29t56 29t53.5 13q37 0 56 -27l90 -111q-48 -55 -103.5 -89.5t-114 -54t-117 -27t-111.5 -7.5q-109 0 -204.5 35.5 t-167 105.5t-113 174t-41.5 242q0 104 35.5 197t102 163t161 111t213.5 41zM570 839q-89 0 -139 -50.5t-66 -145.5h387q0 37 -9.5 72t-31 62.5t-56.5 44.5t-85 17zM494 1473q47 0 70 -15.5t40 -44.5l136 -245h-176q-35 0 -56 9.5t-44 32.5l-260 263h290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 1088,
    d: "M564 1053q103 0 188.5 -32t147 -93t96 -149.5t34.5 -200.5q0 -35 -3 -57t-11 -35t-21.5 -18t-34.5 -5h-598q15 -130 79 -188.5t165 -58.5q54 0 93 13t69.5 29t56 29t53.5 13q37 0 56 -27l90 -111q-48 -55 -103.5 -89.5t-114 -54t-117 -27t-111.5 -7.5q-109 0 -204.5 35.5 t-167 105.5t-113 174t-41.5 242q0 104 35.5 197t102 163t161 111t213.5 41zM570 839q-89 0 -139 -50.5t-66 -145.5h387q0 37 -9.5 72t-31 62.5t-56.5 44.5t-85 17zM968 1473l-260 -263q-23 -23 -44 -32.5t-56 -9.5h-186l136 245q17 29 40 44.5t70 15.5h300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 1088,
    d: "M564 1053q103 0 188.5 -32t147 -93t96 -149.5t34.5 -200.5q0 -35 -3 -57t-11 -35t-21.5 -18t-34.5 -5h-598q15 -130 79 -188.5t165 -58.5q54 0 93 13t69.5 29t56 29t53.5 13q37 0 56 -27l90 -111q-48 -55 -103.5 -89.5t-114 -54t-117 -27t-111.5 -7.5q-109 0 -204.5 35.5 t-167 105.5t-113 174t-41.5 242q0 104 35.5 197t102 163t161 111t213.5 41zM570 839q-89 0 -139 -50.5t-66 -145.5h387q0 37 -9.5 72t-31 62.5t-56.5 44.5t-85 17zM952 1168h-206q-18 0 -33 5.5t-27 14.5l-84 72q-7 5 -13 11t-12 14q-6 -8 -12.5 -14t-12.5 -11l-86 -72 q-9 -8 -25.5 -14t-34.5 -6h-214l234 289h292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 1088,
    d: "M564 1053q103 0 188.5 -32t147 -93t96 -149.5t34.5 -200.5q0 -35 -3 -57t-11 -35t-21.5 -18t-34.5 -5h-598q15 -130 79 -188.5t165 -58.5q54 0 93 13t69.5 29t56 29t53.5 13q37 0 56 -27l90 -111q-48 -55 -103.5 -89.5t-114 -54t-117 -27t-111.5 -7.5q-109 0 -204.5 35.5 t-167 105.5t-113 174t-41.5 242q0 104 35.5 197t102 163t161 111t213.5 41zM570 839q-89 0 -139 -50.5t-66 -145.5h387q0 37 -9.5 72t-31 62.5t-56.5 44.5t-85 17zM540 1295q0 -32 -13 -60t-35.5 -48.5t-52 -32.5t-63.5 -12q-32 0 -60.5 12t-50 32.5t-34.5 48.5t-13 60 q0 33 13 62t34.5 50.5t50 34t60.5 12.5q34 0 63.5 -12.5t52 -34t35.5 -50.5t13 -62zM926 1295q0 -32 -12.5 -60t-34.5 -48.5t-51.5 -32.5t-63.5 -12q-33 0 -62 12t-51 32.5t-34.5 48.5t-12.5 60q0 33 12.5 62t34.5 50.5t51 34t62 12.5q34 0 63.5 -12.5t51.5 -34t34.5 -50.5 t12.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 570,
    d: "M440 1037v-1037h-310v1037h310zM217 1473q47 0 70 -15.5t40 -44.5l136 -245h-176q-35 0 -56 9.5t-44 32.5l-260 263h290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 570,
    d: "M440 1037v-1037h-310v1037h310zM691 1473l-260 -263q-23 -23 -44 -32.5t-56 -9.5h-186l136 245q17 29 40 44.5t70 15.5h300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 570,
    d: "M440 1037v-1037h-310v1037h310zM675 1168h-206q-18 0 -33 5.5t-27 14.5l-84 72q-7 5 -13 11t-12 14q-6 -8 -12.5 -14t-12.5 -11l-86 -72q-9 -8 -25.5 -14t-34.5 -6h-214l234 289h292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 570,
    d: "M440 1037v-1037h-310v1037h310zM263 1295q0 -32 -13 -60t-35.5 -48.5t-52 -32.5t-63.5 -12q-32 0 -60.5 12t-50 32.5t-34.5 48.5t-13 60q0 33 13 62t34.5 50.5t50 34t60.5 12.5q34 0 63.5 -12.5t52 -34t35.5 -50.5t13 -62zM649 1295q0 -32 -12.5 -60t-34.5 -48.5 t-51.5 -32.5t-63.5 -12q-33 0 -62 12t-51 32.5t-34.5 48.5t-12.5 60q0 33 12.5 62t34.5 50.5t51 34t62 12.5q34 0 63.5 -12.5t51.5 -34t34.5 -50.5t12.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 1162,
    d: "M358 1059q-13 21 -13 40q0 17 10.5 32t30.5 24l46 22q-20 7 -40 13.5t-42 12.5q-31 8 -50.5 29.5t-19.5 57.5q0 24 10 53l36 103q106 -17 203 -49t182 -81l183 107l62 -98q11 -17 11 -36q0 -17 -9 -31.5t-26 -22.5l-66 -33q109 -103 171.5 -249.5t62.5 -341.5 q0 -150 -35.5 -266.5t-104 -197t-168.5 -122t-228 -41.5q-109 0 -202 33.5t-161 97.5t-106.5 156t-38.5 209q0 90 33.5 172.5t95 145.5t147.5 100t190 37q90 0 160.5 -28t127.5 -79q-20 82 -63 145t-119 114l-212 -124zM572 212q45 0 86 16.5t73.5 56t52.5 107t23 169.5 q-29 63 -82.5 104.5t-138.5 41.5q-54 0 -95.5 -18t-69.5 -49t-42.5 -72.5t-14.5 -89.5q0 -65 16 -115t44 -83.5t66 -50.5t82 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    d: "M120 0v1037h192q29 0 48.5 -13t27.5 -39l18 -60q30 28 62 52t68.5 40.5t79 26t92.5 9.5q85 0 150.5 -29.5t110.5 -82t68 -125t23 -157.5v-659h-310v659q0 76 -35 118.5t-103 42.5q-51 0 -96 -22t-86 -59v-739h-310zM694 1387q24 0 39 12.5t15 53.5h188 q0 -63 -17.5 -113.5t-48.5 -86t-73 -54.5t-91 -19q-37 0 -69 11.5t-59.5 25.5t-50 25.5t-39.5 11.5q-24 0 -38 -13.5t-14 -54.5h-190q0 63 18 113.5t49 86.5t73 55.5t90 19.5q37 0 69.5 -11.5t59.5 -25.5t49.5 -25.5t39.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    d: "M582 1053q118 0 215 -37t166.5 -106t108 -167.5t38.5 -221.5q0 -124 -38.5 -223.5t-108 -169t-166.5 -107t-215 -37.5q-119 0 -216.5 37.5t-168 107t-109 169t-38.5 223.5q0 123 38.5 221.5t109 167.5t168 106t216.5 37zM582 214q107 0 157.5 75.5t50.5 229.5t-50.5 229 t-157.5 75q-110 0 -161 -75t-51 -229t51 -229.5t161 -75.5zM504 1473q47 0 70 -15.5t40 -44.5l136 -245h-176q-35 0 -56 9.5t-44 32.5l-260 263h290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    d: "M582 1053q118 0 215 -37t166.5 -106t108 -167.5t38.5 -221.5q0 -124 -38.5 -223.5t-108 -169t-166.5 -107t-215 -37.5q-119 0 -216.5 37.5t-168 107t-109 169t-38.5 223.5q0 123 38.5 221.5t109 167.5t168 106t216.5 37zM582 214q107 0 157.5 75.5t50.5 229.5t-50.5 229 t-157.5 75q-110 0 -161 -75t-51 -229t51 -229.5t161 -75.5zM978 1473l-260 -263q-23 -23 -44 -32.5t-56 -9.5h-186l136 245q17 29 40 44.5t70 15.5h300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    d: "M582 1053q118 0 215 -37t166.5 -106t108 -167.5t38.5 -221.5q0 -124 -38.5 -223.5t-108 -169t-166.5 -107t-215 -37.5q-119 0 -216.5 37.5t-168 107t-109 169t-38.5 223.5q0 123 38.5 221.5t109 167.5t168 106t216.5 37zM582 214q107 0 157.5 75.5t50.5 229.5t-50.5 229 t-157.5 75q-110 0 -161 -75t-51 -229t51 -229.5t161 -75.5zM962 1168h-206q-18 0 -33 5.5t-27 14.5l-84 72q-7 5 -13 11t-12 14q-6 -8 -12.5 -14t-12.5 -11l-86 -72q-9 -8 -25.5 -14t-34.5 -6h-214l234 289h292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    d: "M582 1053q118 0 215 -37t166.5 -106t108 -167.5t38.5 -221.5q0 -124 -38.5 -223.5t-108 -169t-166.5 -107t-215 -37.5q-119 0 -216.5 37.5t-168 107t-109 169t-38.5 223.5q0 123 38.5 221.5t109 167.5t168 106t216.5 37zM582 214q107 0 157.5 75.5t50.5 229.5t-50.5 229 t-157.5 75q-110 0 -161 -75t-51 -229t51 -229.5t161 -75.5zM686 1387q24 0 39 12.5t15 53.5h188q0 -63 -17.5 -113.5t-48.5 -86t-73 -54.5t-91 -19q-37 0 -69 11.5t-59.5 25.5t-50 25.5t-39.5 11.5q-24 0 -38 -13.5t-14 -54.5h-190q0 63 18 113.5t49 86.5t73 55.5t90 19.5 q37 0 69.5 -11.5t59.5 -25.5t49.5 -25.5t39.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    d: "M582 1053q118 0 215 -37t166.5 -106t108 -167.5t38.5 -221.5q0 -124 -38.5 -223.5t-108 -169t-166.5 -107t-215 -37.5q-119 0 -216.5 37.5t-168 107t-109 169t-38.5 223.5q0 123 38.5 221.5t109 167.5t168 106t216.5 37zM582 214q107 0 157.5 75.5t50.5 229.5t-50.5 229 t-157.5 75q-110 0 -161 -75t-51 -229t51 -229.5t161 -75.5zM550 1295q0 -32 -13 -60t-35.5 -48.5t-52 -32.5t-63.5 -12q-32 0 -60.5 12t-50 32.5t-34.5 48.5t-13 60q0 33 13 62t34.5 50.5t50 34t60.5 12.5q34 0 63.5 -12.5t52 -34t35.5 -50.5t13 -62zM936 1295 q0 -32 -12.5 -60t-34.5 -48.5t-51.5 -32.5t-63.5 -12q-33 0 -62 12t-51 32.5t-34.5 48.5t-12.5 60q0 33 12.5 62t34.5 50.5t51 34t62 12.5q34 0 63.5 -12.5t51.5 -34t34.5 -50.5t12.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    d: "M84 783h990v-222h-990v222zM402 1028q0 36 13.5 67t37 54t55.5 36.5t70 13.5q37 0 69 -13.5t56 -36.5t37.5 -54t13.5 -67t-13.5 -67.5t-37.5 -54.5t-56 -36t-69 -13q-38 0 -70 13t-55.5 36t-37 54.5t-13.5 67.5zM402 316q0 36 13.5 67t37 54t55.5 36.5t70 13.5 q37 0 69 -13.5t56 -36.5t37.5 -54t13.5 -67t-13.5 -67.5t-37.5 -54.5t-56 -36t-69 -13q-38 0 -70 13t-55.5 36t-37 54.5t-13.5 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    d: "M974 899q65 -69 100.5 -164.5t35.5 -213.5q0 -124 -38.5 -223.5t-108 -169t-166.5 -107t-215 -37.5q-135 0 -245 49l-17 -24q-17 -25 -38.5 -41.5t-46 -26.5t-50 -14.5t-49.5 -4.5h-112l161 219q-65 69 -100 165t-35 215q0 123 38.5 221.5t109 167.5t168 106t216.5 37 q132 0 238 -47l46 62q16 21 29.5 36t28.5 24.5t34 13.5t46 4h152zM582 205q107 0 167.5 80t60.5 234q0 78 -14 137l-318 -431q43 -20 104 -20zM350 519q0 -80 13 -135l316 430q-41 19 -97 19q-110 0 -171 -80t-61 -234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    d: "M410 1037v-658q0 -77 35 -119t103 -42q51 0 95.5 21t86.5 59v739h310v-1037h-192q-58 0 -76 52l-19 60q-30 -29 -62 -52.5t-68.5 -40t-78.5 -26t-92 -9.5q-85 0 -150.5 29.5t-110.5 82.5t-68 125t-23 158v658h310zM500 1473q47 0 70 -15.5t40 -44.5l136 -245h-176 q-35 0 -56 9.5t-44 32.5l-260 263h290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    d: "M410 1037v-658q0 -77 35 -119t103 -42q51 0 95.5 21t86.5 59v739h310v-1037h-192q-58 0 -76 52l-19 60q-30 -29 -62 -52.5t-68.5 -40t-78.5 -26t-92 -9.5q-85 0 -150.5 29.5t-110.5 82.5t-68 125t-23 158v658h310zM974 1473l-260 -263q-23 -23 -44 -32.5t-56 -9.5h-186 l136 245q17 29 40 44.5t70 15.5h300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    d: "M410 1037v-658q0 -77 35 -119t103 -42q51 0 95.5 21t86.5 59v739h310v-1037h-192q-58 0 -76 52l-19 60q-30 -29 -62 -52.5t-68.5 -40t-78.5 -26t-92 -9.5q-85 0 -150.5 29.5t-110.5 82.5t-68 125t-23 158v658h310zM958 1168h-206q-18 0 -33 5.5t-27 14.5l-84 72 q-7 5 -13 11t-12 14q-6 -8 -12.5 -14t-12.5 -11l-86 -72q-9 -8 -25.5 -14t-34.5 -6h-214l234 289h292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    d: "M410 1037v-658q0 -77 35 -119t103 -42q51 0 95.5 21t86.5 59v739h310v-1037h-192q-58 0 -76 52l-19 60q-30 -29 -62 -52.5t-68.5 -40t-78.5 -26t-92 -9.5q-85 0 -150.5 29.5t-110.5 82.5t-68 125t-23 158v658h310zM546 1295q0 -32 -13 -60t-35.5 -48.5t-52 -32.5 t-63.5 -12q-32 0 -60.5 12t-50 32.5t-34.5 48.5t-13 60q0 33 13 62t34.5 50.5t50 34t60.5 12.5q34 0 63.5 -12.5t52 -34t35.5 -50.5t13 -62zM932 1295q0 -32 -12.5 -60t-34.5 -48.5t-51.5 -32.5t-63.5 -12q-33 0 -62 12t-51 32.5t-34.5 48.5t-12.5 60q0 33 12.5 62 t34.5 50.5t51 34t62 12.5q34 0 63.5 -12.5t51.5 -34t34.5 -50.5t12.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 1106,
    d: "M544 -269q-14 -31 -34 -45.5t-64 -14.5h-232l200 420l-414 946h274q36 0 56 -16t28 -38l170 -447q24 -62 39 -124q10 32 22 63t23 63l154 445q8 23 31.5 38.5t50.5 15.5h250zM966 1473l-260 -263q-23 -23 -44 -32.5t-56 -9.5h-186l136 245q17 29 40 44.5t70 15.5h300z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 1156,
    d: "M120 -329v1826h310v-570q58 57 131.5 91.5t172.5 34.5q81 0 150 -35t119 -102.5t78.5 -165.5t28.5 -223q0 -117 -32.5 -216t-91 -172t-140 -114t-180.5 -41q-41 0 -75 7.5t-62.5 21t-52.5 32.5t-46 42v-416h-310zM626 820q-34 0 -61.5 -6.5t-51 -18.5t-43.5 -30.5 t-40 -42.5v-440q35 -39 76 -54.5t86 -15.5q43 0 79 17t62.5 54.5t41.5 97.5t15 146q0 82 -12 138t-33.5 90.5t-51.5 49.5t-67 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 1106,
    d: "M544 -269q-14 -31 -34 -45.5t-64 -14.5h-232l200 420l-414 946h274q36 0 56 -16t28 -38l170 -447q24 -62 39 -124q10 32 22 63t23 63l154 445q8 23 31.5 38.5t50.5 15.5h250zM538 1295q0 -32 -13 -60t-35.5 -48.5t-52 -32.5t-63.5 -12q-32 0 -60.5 12t-50 32.5 t-34.5 48.5t-13 60q0 33 13 62t34.5 50.5t50 34t60.5 12.5q34 0 63.5 -12.5t52 -34t35.5 -50.5t13 -62zM924 1295q0 -32 -12.5 -60t-34.5 -48.5t-51.5 -32.5t-63.5 -12q-33 0 -62 12t-51 32.5t-34.5 48.5t-12.5 60q0 33 12.5 62t34.5 50.5t51 34t62 12.5q34 0 63.5 -12.5 t51.5 -34t34.5 -50.5t12.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 1474,
    d: "M1426 -167q21 0 28 -19l46 -111q-35 -21 -87 -35.5t-111 -14.5q-107 0 -162.5 42t-55.5 107q0 51 33.5 102t108.5 96h-12q-44 0 -72.5 20.5t-39.5 52.5l-86 254h-554l-86 -254q-10 -28 -39 -50.5t-71 -22.5h-264l564 1457h346l564 -1457h-68q-39 -21 -66.5 -52.5 t-27.5 -69.5q0 -24 13.5 -38.5t40.5 -14.5q15 0 24 1t15 2.5t10 3t9 1.5zM540 557h398l-134 399q-15 38 -32 89.5t-34 111.5q-16 -61 -32.5 -113t-31.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 1078,
    d: "M996 -167q21 0 28 -19l46 -111q-35 -21 -87 -35.5t-111 -14.5q-107 0 -162.5 42t-55.5 107q0 52 35 103.5t111 96.5q-26 4 -41.5 17.5t-26.5 42.5l-22 57q-39 -33 -75 -58t-74.5 -42.5t-82 -26t-96.5 -8.5q-71 0 -129 18.5t-98.5 54.5t-62.5 89.5t-22 123.5q0 55 28 113 t97 105.5t186 79.5t295 36v44q0 91 -37.5 131.5t-106.5 40.5q-55 0 -90 -12t-62.5 -27t-53.5 -27t-62 -12q-32 0 -54.5 15.5t-35.5 38.5l-56 97q94 83 208.5 123.5t245.5 40.5q94 0 169.5 -30.5t128 -85t80.5 -129.5t28 -164v-648q-39 -21 -66.5 -52.5t-27.5 -69.5 q0 -24 13.5 -38.5t40.5 -14.5q15 0 24 1t15 2.5t10 3t9 1.5zM480 189q60 0 105 21t91 68v144q-93 -4 -153 -16t-95 -30t-48.5 -41t-13.5 -50q0 -53 29 -74.5t85 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 1314,
    d: "M1099 377q12 0 24 -4.5t23 -15.5l134 -141q-88 -115 -220.5 -173.5t-313.5 -58.5q-166 0 -297.5 56.5t-223 156t-140.5 236t-49 296.5q0 163 56 299.5t156.5 235.5t240.5 154t309 55q82 0 154.5 -14.5t135.5 -40t116 -61t94 -78.5l-114 -153q-11 -14 -26 -25.5t-42 -11.5 q-18 0 -34 8t-34 19.5t-39.5 25t-51 25t-69 19.5t-92.5 8q-92 0 -168 -32.5t-130.5 -93t-85 -146.5t-30.5 -193q0 -112 30.5 -199t83 -146.5t122.5 -90.5t150 -31q46 0 84 4.5t70.5 15.5t62 28.5t59.5 43.5q12 10 26 16.5t29 6.5zM1210 1798l-295 -214q-26 -20 -48.5 -26.5 t-56.5 -6.5h-246l181 197q13 15 25.5 24.5t26.5 15.5t31 8t40 2h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 972,
    d: "M868 791q-14 -17 -27 -27t-37 -10q-23 0 -41.5 11t-41.5 24.5t-54 24.5t-77 11q-57 0 -98.5 -21t-68.5 -60t-40 -95.5t-13 -127.5q0 -149 57.5 -229t158.5 -80q54 0 85.5 13.5t53.5 30t40.5 30.5t46.5 14q37 0 56 -27l90 -111q-48 -55 -101 -89.5t-108.5 -54t-111.5 -27 t-109 -7.5q-95 0 -181.5 36t-152 104.5t-104 168.5t-38.5 228q0 112 33.5 209.5t99 169t162 112.5t223.5 41q122 0 214 -39t166 -114zM962 1473l-260 -263q-23 -23 -44 -32.5t-56 -9.5h-186l136 245q17 29 40 44.5t70 15.5h300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 1130,
    d: "M984 -167q21 0 28 -19l46 -111q-35 -21 -87 -35.5t-111 -14.5q-107 0 -162.5 42t-55.5 107q0 51 33.5 102t108.5 96h-664v1457h938v-260h-598v-340h458v-250h-458v-347h598v-260h-92q-39 -21 -66.5 -52.5t-27.5 -69.5q0 -24 13.5 -38.5t40.5 -14.5q15 0 24 1t15 2.5t10 3 t9 1.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 1088,
    d: "M744 -167q21 0 28 -19l46 -111q-35 -21 -87 -35.5t-111 -14.5q-107 0 -162.5 42t-55.5 107q0 48 29 95.5t92 89.5q-99 8 -185 47.5t-149.5 109t-100 169t-36.5 228.5q0 104 35.5 197t102 163t161 111t213.5 41q103 0 188.5 -32t147 -93t96 -149.5t34.5 -200.5 q0 -35 -3 -57t-11 -35t-21.5 -18t-34.5 -5h-598q15 -130 79 -188.5t165 -58.5q54 0 93 13t69.5 29t56 29t53.5 13q37 0 56 -27l90 -111q-66 -76 -146 -114t-160 -52q-36 -21 -61 -51t-25 -67q0 -24 13.5 -38.5t40.5 -14.5q15 0 24 1t15 2.5t10 3t9 1.5zM570 839 q-89 0 -139 -50.5t-66 -145.5h387q0 37 -9.5 72t-31 62.5t-56.5 44.5t-85 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 570,
    d: "M440 1037v-1037h-310v1037h310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 1116,
    d: "M536 923l334 165v-221q0 -48 -40 -62l-294 -152v-383h540v-270h-878v505l-174 -85v228q0 39 36 54l138 71v684h338v-534z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 710,
    d: "M510 1497v-546l150 59v-174q0 -45 -40 -62l-110 -46v-728h-310v624l-150 -58v180q0 39 36 54l114 47v650h310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 1512,
    d: "M298 1457q22 0 37 -2t27 -7.5t23 -15.5t25 -27l692 -875q-4 42 -6 81.5t-2 74.5v771h298v-1457h-176q-39 0 -66 12t-52 44l-687 868q3 -38 5 -74.5t2 -68.5v-781h-298v1457h178v0zM1188 1798l-295 -214q-26 -20 -48.5 -26.5t-56.5 -6.5h-246l181 197q13 15 25.5 24.5 t26.5 15.5t31 8t40 2h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    d: "M120 0v1037h192q29 0 48.5 -13t27.5 -39l18 -60q30 28 62 52t68.5 40.5t79 26t92.5 9.5q85 0 150.5 -29.5t110.5 -82t68 -125t23 -157.5v-659h-310v659q0 76 -35 118.5t-103 42.5q-51 0 -96 -22t-86 -59v-739h-310zM994 1473l-260 -263q-23 -23 -44 -32.5t-56 -9.5h-186 l136 245q17 29 40 44.5t70 15.5h300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 2136,
    d: "M2064 1457v-260h-598v-340h458v-250h-458v-347h598v-260h-898v148q-86 -78 -196.5 -121t-243.5 -43q-154 0 -279.5 57t-215 157.5t-138.5 236.5t-49 294t49 294t138.5 236t215 157t279.5 57q133 0 243.5 -43.5t196.5 -121.5v149h898zM1126 729q0 108 -24.5 196 t-71.5 149.5t-115 95t-155 33.5q-89 0 -157.5 -33.5t-116 -95t-72 -149.5t-24.5 -196q0 -109 24.5 -197t72 -149.5t116 -95t157.5 -33.5q87 0 155 33.5t115 95t71.5 149.5t24.5 197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1762,
    d: "M1274 1053q92 0 171 -35t136.5 -99.5t90 -156t32.5 -204.5q0 -35 -3 -57t-10.5 -35t-20.5 -18t-34 -5h-570q17 -119 77.5 -173t152.5 -54q51 0 87.5 13t65 29t53.5 29t54 13q17 0 30.5 -7.5t23.5 -19.5l92 -111q-48 -55 -102.5 -89.5t-111.5 -54t-113.5 -27t-108.5 -7.5 q-51 0 -100 10.5t-94.5 32.5t-86 55.5t-72.5 79.5q-63 -86 -159 -132t-220 -46q-103 0 -191.5 37.5t-153.5 107t-102 169t-37 223.5q0 123 37.5 221.5t103.5 167.5t157 106t198 37q118 0 210.5 -45t155.5 -130q58 81 148.5 128t213.5 47zM564 214q100 0 146 75.5t46 229.5 t-46 229t-146 75q-101 0 -147.5 -75t-46.5 -229t46.5 -229.5t147.5 -75.5zM1260 839q-88 0 -135.5 -55.5t-60.5 -160.5h364q0 37 -8.5 75.5t-28 69.5t-52 51t-79.5 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 1118,
    d: "M932 1161q-15 -24 -31.5 -36t-42.5 -12q-23 0 -49.5 14.5t-60 32.5t-76.5 32.5t-98 14.5q-95 0 -141.5 -40.5t-46.5 -109.5q0 -44 28 -73t73.5 -50t104 -38.5t119.5 -39t119.5 -50.5t104 -74t73.5 -109.5t28 -155.5q0 -101 -35 -189t-101.5 -153.5t-164 -103 t-221.5 -37.5q-68 0 -138.5 14t-136.5 39.5t-124 60.5t-101 78l100 158q11 18 31 29t43 11q30 0 60.5 -19t69 -42t88.5 -42t118 -19q92 0 143 40.5t51 128.5q0 51 -28 83t-73.5 53t-103.5 37t-119 35.5t-119 48t-103.5 75t-73.5 116t-28 171.5q0 82 33 160t97 139t157 97.5 t213 36.5q67 0 130.5 -10.5t120.5 -31t106.5 -49t88.5 -64.5zM1028 1798l-295 -214q-26 -20 -48.5 -26.5t-56.5 -6.5h-246l181 197q13 15 25.5 24.5t26.5 15.5t31 8t40 2h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 880,
    d: "M754 810q-12 -19 -25.5 -27t-34.5 -8q-22 0 -44 9.5t-47.5 20.5t-57.5 20.5t-73 9.5q-59 0 -90.5 -22.5t-31.5 -62.5q0 -29 20.5 -48t54.5 -33.5t77 -27.5t88 -29t88 -37.5t77 -53t54.5 -76.5t20.5 -108q0 -77 -28 -142t-83.5 -112t-137 -73t-187.5 -26q-53 0 -106 10 t-102.5 27t-91.5 40.5t-72 50.5l72 114q13 20 31 31.5t47 11.5q27 0 48.5 -12t46.5 -26t58.5 -26t84.5 -12q36 0 61 7.5t40 20.5t22 29t7 33q0 31 -21 51t-55 34.5t-77.5 27t-88.5 28.5t-88.5 38.5t-77.5 57t-55 84.5t-21 121q0 66 25.5 125.5t76.5 104.5t128 71.5t180 26.5 q56 0 108.5 -10t98.5 -28t84 -42.5t67 -53.5zM860 1473l-260 -263q-23 -23 -44 -32.5t-56 -9.5h-186l136 245q17 29 40 44.5t70 15.5h300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 1084,
    d: "M932 1161q-15 -24 -31.5 -36t-42.5 -12q-23 0 -49.5 14.5t-60 32.5t-76.5 32.5t-98 14.5q-95 0 -141.5 -40.5t-46.5 -109.5q0 -44 28 -73t73.5 -50t104 -38.5t119.5 -39t119.5 -50.5t104 -74t73.5 -109.5t28 -155.5q0 -101 -35 -189t-101.5 -153.5t-164 -103 t-221.5 -37.5q-68 0 -138.5 14t-136.5 39.5t-124 60.5t-101 78l100 158q11 18 31 29t43 11q30 0 60.5 -19t69 -42t88.5 -42t118 -19q92 0 143 40.5t51 128.5q0 51 -28 83t-73.5 53t-103.5 37t-119 35.5t-119 48t-103.5 75t-73.5 116t-28 171.5q0 82 33 160t97 139t157 97.5 t213 36.5q67 0 130.5 -10.5t120.5 -31t106.5 -49t88.5 -64.5zM186 1778h234q18 0 39 -5t35 -13l74 -45q5 -3 9 -5.5t9 -6.5q4 3 8.5 6t9.5 6l74 45q14 8 35 13t39 5h234l-244 -227h-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 880,
    d: "M754 810q-12 -19 -25.5 -27t-34.5 -8q-22 0 -44 9.5t-47.5 20.5t-57.5 20.5t-73 9.5q-59 0 -90.5 -22.5t-31.5 -62.5q0 -29 20.5 -48t54.5 -33.5t77 -27.5t88 -29t88 -37.5t77 -53t54.5 -76.5t20.5 -108q0 -77 -28 -142t-83.5 -112t-137 -73t-187.5 -26q-53 0 -106 10 t-102.5 27t-91.5 40.5t-72 50.5l72 114q13 20 31 31.5t47 11.5q27 0 48.5 -12t46.5 -26t58.5 -26t84.5 -12q36 0 61 7.5t40 20.5t22 29t7 33q0 31 -21 51t-55 34.5t-77.5 27t-88.5 28.5t-88.5 38.5t-77.5 57t-55 84.5t-21 121q0 66 25.5 125.5t76.5 104.5t128 71.5t180 26.5 q56 0 108.5 -10t98.5 -28t84 -42.5t67 -53.5zM82 1457h214q18 0 34.5 -5.5t25.5 -13.5l84 -72q6 -5 13 -12t13 -15q11 16 26 27l84 72q9 6 25.5 12.5t34.5 6.5h206l-234 -289h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 1354,
    d: "M846 554v-554h-338v554l-528 903h298q44 0 70 -20.5t42 -52.5l206 -424q25 -51 46 -94t37 -85q15 43 36 86t45 93l204 424q6 13 16.5 26t24 23.5t31 17t38.5 6.5h300zM616 1668q0 -32 -12.5 -59t-34.5 -47.5t-51 -32t-62 -11.5q-30 0 -57.5 11.5t-48.5 32t-33.5 47.5 t-12.5 59q0 31 12.5 59t33.5 49t48.5 33t57.5 12q33 0 62 -12t51 -33t34.5 -49t12.5 -59zM1056 1668q0 -32 -12.5 -59t-33.5 -47.5t-49.5 -32t-60.5 -11.5t-60.5 11.5t-49.5 32t-33.5 47.5t-12.5 59q0 31 12.5 59t33.5 49t49.5 33t60.5 12t60.5 -12t49.5 -33t33.5 -49 t12.5 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 1220,
    d: "M1186 1457v-122q0 -26 -8.5 -51t-23.5 -47l-684 -977h694v-260h-1124v130q0 23 8 45.5t22 41.5l686 980h-660v260h1090zM1068 1798l-295 -214q-26 -20 -48.5 -26.5t-56.5 -6.5h-246l181 197q13 15 25.5 24.5t26.5 15.5t31 8t40 2h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 954,
    d: "M894 913q0 -32 -12 -61t-28 -50l-433 -572h463v-230h-820v126q0 19 10.5 47.5t29.5 54.5l437 579h-449v230h802v-124zM904 1473l-260 -263q-23 -23 -44 -32.5t-56 -9.5h-186l136 245q17 29 40 44.5t70 15.5h300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 1220,
    d: "M1186 1457v-122q0 -26 -8.5 -51t-23.5 -47l-684 -977h694v-260h-1124v130q0 23 8 45.5t22 41.5l686 980h-660v260h1090zM822 1701q0 -34 -14.5 -65t-39 -54t-58 -37t-70.5 -14q-35 0 -66.5 14t-55.5 37t-38 54t-14 65q0 36 14 67.5t38 55.5t55.5 38t66.5 14 q37 0 70.5 -14t58 -38t39 -55.5t14.5 -67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 954,
    d: "M894 913q0 -32 -12 -61t-28 -50l-433 -572h463v-230h-820v126q0 19 10.5 47.5t29.5 54.5l437 579h-449v230h802v-124zM698 1322q0 -37 -15 -70t-41 -57.5t-60.5 -38.5t-73.5 -14q-38 0 -71 14t-58.5 38.5t-40 57.5t-14.5 70t14.5 70.5t40 58t58.5 39t71 14.5 q39 0 73.5 -14.5t60.5 -39t41 -58t15 -70.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 1220,
    d: "M1186 1457v-122q0 -26 -8.5 -51t-23.5 -47l-684 -977h694v-260h-1124v130q0 23 8 45.5t22 41.5l686 980h-660v260h1090zM244 1777h234q18 0 39 -5t35 -13l74 -45q5 -3 9 -5.5t9 -6.5q4 3 8.5 6t9.5 6l74 45q14 8 35 13t39 5h234l-244 -227h-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 954,
    d: "M894 913q0 -32 -12 -61t-28 -50l-433 -572h463v-230h-820v126q0 19 10.5 47.5t29.5 54.5l437 579h-449v230h802v-124zM128 1457h214q18 0 34.5 -5.5t25.5 -13.5l84 -72q6 -5 13 -12t13 -15q11 16 26 27l84 72q9 6 25.5 12.5t34.5 6.5h206l-234 -289h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    d: "M737 727l-79 -655q-13 -109 -52.5 -186.5t-108.5 -127.5t-170 -73.5t-237 -23.5v157q0 48 23 70t73 22q36 0 64 9t48 29.5t33 53.5t19 80l79 640l-95 20q-33 8 -50.5 25.5t-17.5 49.5v122h189l17 134q13 102 52 179t108 128.5t170 78t238 26.5v-165q0 -48 -23 -66 t-73 -18q-72 0 -115.5 -39t-56.5 -133l-17 -125h269v-212h-287z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 660,
    d: "M710 1168h-206q-18 0 -33 5.5t-27 14.5l-84 72q-7 5 -13 11t-12 14q-6 -8 -12.5 -14t-12.5 -11l-86 -72q-9 -8 -25.5 -14t-34.5 -6h-214l234 289h292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 660,
    d: "M-50 1457h214q18 0 34.5 -5.5t25.5 -13.5l84 -72q6 -5 13 -12t13 -15q11 16 26 27l84 72q9 6 25.5 12.5t34.5 6.5h206l-234 -289h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 660,
    d: "M20 1391h620v-190h-620v190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 660,
    d: "M330 1159q-94 0 -157 24t-101 64.5t-54 94.5t-16 115h216q0 -27 4.5 -48t17 -34.5t34 -20.5t56.5 -7q34 0 56 7t34.5 20.5t17 34.5t4.5 48h216q0 -61 -16 -115t-54 -94.5t-101 -64.5t-157 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 660,
    d: "M518 1322q0 -37 -15 -70t-41 -57.5t-60.5 -38.5t-73.5 -14q-38 0 -71 14t-58.5 38.5t-40 57.5t-14.5 70t14.5 70.5t40 58t58.5 39t71 14.5q39 0 73.5 -14.5t60.5 -39t41 -58t15 -70.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 660,
    d: "M86 1334q0 50 20 90.5t53 69.5t77 44.5t92 15.5q49 0 94 -15.5t79.5 -44.5t54.5 -69.5t20 -90.5q0 -49 -20 -88.5t-54.5 -67.5t-79.5 -43.5t-94 -15.5q-48 0 -92 15.5t-77 43.5t-53 67.5t-20 88.5zM252 1334q0 -35 19.5 -57.5t60.5 -22.5q36 0 57 22.5t21 57.5 q0 38 -21 60t-57 22q-41 0 -60.5 -22t-19.5 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 660,
    d: "M470 -167q21 0 28 -19l46 -111q-35 -21 -87 -35.5t-111 -14.5q-107 0 -162.5 42t-55.5 107q0 55 39 109.5t125 100.5l160 -12q-39 -21 -66.5 -52.5t-27.5 -69.5q0 -24 13.5 -38.5t40.5 -14.5q15 0 24 1t15 2.5t10 3t9 1.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 660,
    d: "M434 1387q24 0 39 12.5t15 53.5h188q0 -63 -17.5 -113.5t-48.5 -86t-73 -54.5t-91 -19q-37 0 -69 11.5t-59.5 25.5t-50 25.5t-39.5 11.5q-24 0 -38 -13.5t-14 -54.5h-190q0 63 18 113.5t49 86.5t73 55.5t90 19.5q37 0 69.5 -11.5t59.5 -25.5t49.5 -25.5t39.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 660,
    d: "M472 1473l-200 -263q-20 -25 -42.5 -33.5t-57.5 -8.5h-126l116 245q14 30 38.5 45t71.5 15h200zM852 1473l-260 -263q-23 -23 -44 -32.5t-56 -9.5h-146l176 245q10 14 19.5 25t22 19t29 12t39.5 4h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 1336,
    d: "M1298 1037v-120q0 -38 -24.5 -65.5t-69.5 -27.5h-80v-824h-310v824h-286v-540q0 -66 -16 -121t-52 -95t-94.5 -62t-143.5 -22q-38 0 -82.5 8.5t-85.5 28.5l8 127q1 20 13 35.5t51 15.5q28 0 46 4.5t28.5 15t14 27.5t3.5 41v537h-170v108q0 17 7.5 35.5t22.5 34t36 25.5 t48 10h1136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    d: "M170 713h820v-212h-820v212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1722,
    d: "M170 713h1382v-212h-1382v212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 472,
    d: "M164 949q-40 63 -59.5 125.5t-19.5 124.5q0 107 56 205.5t165 181.5l98 -58q12 -8 17.5 -17.5t5.5 -19.5q0 -11 -5 -21t-12 -17q-11 -12 -24.5 -29.5t-25.5 -41t-20.5 -52t-8.5 -61.5q0 -36 12.5 -77t41.5 -88q10 -16 10 -32q0 -18 -12 -32t-33 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 472,
    d: "M338 1551q40 -63 59.5 -126t19.5 -125q0 -107 -56 -205t-165 -181l-98 58q-12 8 -17.5 17.5t-5.5 19.5q0 11 5 21t12 17q11 12 24.5 29.5t25.5 40.5t20.5 52t8.5 62q0 36 -12.5 77t-41.5 88q-10 16 -10 32q0 18 12 32t33 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 472,
    d: "M338 332q40 -63 59.5 -126t19.5 -125q0 -107 -56 -205t-165 -181l-98 58q-12 8 -17.5 17.5t-5.5 19.5q0 11 5 21t12 17q11 12 24.5 29.5t25.5 40.5t20.5 52t8.5 62q0 36 -12.5 77t-41.5 88q-10 16 -10 32q0 18 12 32t33 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 830,
    d: "M164 949q-40 63 -59.5 125.5t-19.5 124.5q0 107 56 205.5t165 181.5l98 -58q12 -8 17.5 -17.5t5.5 -19.5q0 -11 -5 -21t-12 -17q-11 -12 -24.5 -29.5t-25.5 -41t-20.5 -52t-8.5 -61.5q0 -36 12.5 -77t41.5 -88q10 -16 10 -32q0 -18 -12 -32t-33 -22zM522 949 q-40 63 -59.5 125.5t-19.5 124.5q0 107 56 205.5t165 181.5l98 -58q12 -8 17.5 -17.5t5.5 -19.5q0 -11 -5 -21t-12 -17q-11 -12 -24.5 -29.5t-25.5 -41t-20.5 -52t-8.5 -61.5q0 -36 12.5 -77t41.5 -88q10 -16 10 -32q0 -18 -12 -32t-33 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 830,
    d: "M338 1551q40 -63 59.5 -126t19.5 -125q0 -107 -56 -205t-165 -181l-98 58q-12 8 -17.5 17.5t-5.5 19.5q0 11 5 21t12 17q11 12 24.5 29.5t25.5 40.5t20.5 52t8.5 62q0 36 -12.5 77t-41.5 88q-10 16 -10 32q0 18 12 32t33 22zM696 1551q40 -63 59.5 -126t19.5 -125 q0 -107 -56 -205t-165 -181l-98 58q-12 8 -17.5 17.5t-5.5 19.5q0 11 5 21t12 17q11 12 24.5 29.5t25.5 40.5t20.5 52t8.5 62q0 36 -12.5 77t-41.5 88q-10 16 -10 32q0 18 12 32t33 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 830,
    d: "M338 332q40 -63 59.5 -126t19.5 -125q0 -107 -56 -205t-165 -181l-98 58q-12 8 -17.5 17.5t-5.5 19.5q0 11 5 21t12 17q11 12 24.5 29.5t25.5 40.5t20.5 52t8.5 62q0 36 -12.5 77t-41.5 88q-10 16 -10 32q0 18 12 32t33 22zM696 332q40 -63 59.5 -126t19.5 -125 q0 -107 -56 -205t-165 -181l-98 58q-12 8 -17.5 17.5t-5.5 19.5q0 11 5 21t12 17q11 12 24.5 29.5t25.5 40.5t20.5 52t8.5 62q0 36 -12.5 77t-41.5 88q-10 16 -10 32q0 18 12 32t33 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    d: "M52 909q0 25 8.5 48t26 41t44.5 28.5t65 10.5q28 0 60.5 -5t66.5 -12.5t69.5 -16t70.5 -15.5l-39 489q33 19 74 28.5t86 9.5t86 -9.5t74 -28.5l-40 -489q35 7 70.5 15.5t70 16t66.5 12.5t61 5q37 0 64.5 -10.5t45 -28.5t26 -41t8.5 -48v-100h-412v-304l40 -819 q-33 -19 -74 -29t-86 -10t-86 10t-74 29l40 819v304h-412v100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    d: "M52 353h412v456h-412v100q0 25 8.5 48t26 41t44.5 28.5t65 10.5q28 0 60.5 -5t66.5 -12.5t69.5 -16t70.5 -15.5l-39 489q33 19 74 28.5t86 9.5t86 -9.5t74 -28.5l-40 -489q35 7 70.5 15.5t70 16t66.5 12.5t61 5q37 0 64.5 -10.5t45 -28.5t26 -41t8.5 -48v-100h-412v-456 h412v-99q0 -25 -8.5 -48.5t-26 -41.5t-45 -28.5t-64.5 -10.5q-29 0 -61 5t-66.5 12.5t-70 16t-70.5 15.5l40 -488q-33 -19 -74 -29t-86 -10t-86 10t-74 29l39 488q-35 -7 -70.5 -15.5t-69.5 -16t-66.5 -12.5t-60.5 -5q-38 0 -65 10.5t-44.5 28.5t-26 41.5t-8.5 48.5v99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    d: "M84 592q0 100 39 188t106 154t157 104t192 38q103 0 193 -38t157.5 -104t106.5 -154t39 -188q0 -99 -39 -187t-106.5 -153t-157.5 -103t-193 -38q-102 0 -192 38t-157 103t-106 153t-39 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 1576,
    d: "M60 157q0 36 13.5 67t37 54t55.5 36.5t70 13.5q37 0 69 -13.5t56 -36.5t37.5 -54t13.5 -67t-13.5 -67.5t-37.5 -54.5t-56 -36t-69 -13q-38 0 -70 13t-55.5 36t-37 54.5t-13.5 67.5zM1164 157q0 36 13.5 67t37 54t55.5 36.5t70 13.5q37 0 69 -13.5t56 -36.5t37.5 -54 t13.5 -67t-13.5 -67.5t-37.5 -54.5t-56 -36t-69 -13q-38 0 -70 13t-55.5 36t-37 54.5t-13.5 67.5zM612 157q0 36 13.5 67t37 54t55.5 36.5t70 13.5q37 0 69 -13.5t56 -36.5t37.5 -54t13.5 -67t-13.5 -67.5t-37.5 -54.5t-56 -36t-69 -13q-38 0 -70 13t-55.5 36t-37 54.5 t-13.5 67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 2384,
    d: "M748 1104q0 -80 -29 -146t-77 -113.5t-111.5 -73.5t-132.5 -26q-76 0 -139.5 26t-110 73.5t-72.5 113.5t-26 146q0 83 26 150.5t72.5 115.5t110 74.5t139.5 26.5t140.5 -26.5t111 -74.5t72.5 -115.5t26 -150.5zM510 1104q0 51 -8.5 84.5t-23.5 53.5t-35.5 28t-44.5 8 t-44 -8t-34 -28t-22 -53.5t-8 -84.5q0 -48 8 -80t22 -51t34 -27t44 -8t44.5 8t35.5 27t23.5 51t8.5 80zM1206 1411q15 17 37 31.5t61 14.5h226l-1098 -1413q-15 -19 -37.5 -31.5t-54.5 -12.5h-232zM1586 342q0 -80 -29 -146.5t-77 -114t-111.5 -73.5t-132.5 -26 q-76 0 -139.5 26t-110 73.5t-72.5 114t-26 146.5q0 83 26 150.5t72.5 115.5t110 74.5t139.5 26.5t140.5 -26.5t111 -74.5t72.5 -115.5t26 -150.5zM1348 342q0 50 -8.5 83.5t-23.5 53.5t-35.5 28t-44.5 8t-44 -8t-34 -28t-22 -53.5t-8 -83.5q0 -48 8 -80t22 -51t34 -27t44 -8 t44.5 8t35.5 27t23.5 51t8.5 80zM2334 342q0 -80 -29 -146.5t-77 -114t-111.5 -73.5t-132.5 -26q-76 0 -139.5 26t-110 73.5t-72.5 114t-26 146.5q0 83 26 150.5t72.5 115.5t110 74.5t139.5 26.5t140.5 -26.5t111 -74.5t72.5 -115.5t26 -150.5zM2096 342q0 50 -8.5 83.5 t-23.5 53.5t-35.5 28t-44.5 8t-44 -8t-34 -28t-22 -53.5t-8 -83.5q0 -48 8 -80t22 -51t34 -27t44 -8t44.5 8t35.5 27t23.5 51t8.5 80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 652,
    d: "M110 525v39l262 402l102 -46q24 -11 35.5 -27t11.5 -36q0 -24 -15 -51l-120 -215q-17 -30 -36 -47q18 -16 36 -46l120 -216q15 -26 15 -50q0 -20 -11.5 -36t-35.5 -27l-102 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 652,
    d: "M280 123l-102 46q-24 11 -35.5 27t-11.5 36q0 24 15 50l120 216q15 28 36 46q-10 9 -19 21t-17 26l-120 215q-15 27 -15 51q0 20 11.5 36t35.5 27l102 46l262 -402v-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 800,
    d: "M118 85q-16 -25 -32.5 -41.5t-35 -26t-39.5 -13.5t-45 -4h-132l848 1359q30 47 68 72.5t92 25.5h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    d: "M40 950h120q25 118 77 214.5t125 164.5t165 105t197 37q142 0 245.5 -56.5t166.5 -149.5l-114 -118q-11 -12 -24.5 -21.5t-35.5 -9.5q-24 0 -40.5 15t-38.5 33.5t-55 33.5t-90 15q-94 0 -160.5 -66.5t-97.5 -196.5h460v-92q0 -13 -6 -26t-17 -23.5t-26.5 -17t-34.5 -6.5 h-397q-1 -14 -1 -28v-28v-35h386v-92q0 -13 -6 -26t-17 -23.5t-26.5 -17t-34.5 -6.5h-286q26 -145 91 -215t159 -70q42 0 72 8.5t51 20.5t35.5 27t27 27t25 20.5t29.5 8.5q14 0 23.5 -4t20.5 -15l136 -121q-69 -113 -181 -171.5t-255 -58.5q-119 0 -213.5 39.5t-164 110.5 t-114 171t-63.5 222h-113v165h98v35v28t1 28h-99v165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 1462,
    d: "M956 1209q19 -42 33 -84q7 21 16 42t19 42l100 217q17 20 29.5 25.5t38.5 5.5h184v-613h-186v252l14 113l-126 -269q-10 -21 -29 -32.5t-43 -11.5h-30q-24 0 -43 11.5t-29 32.5l-120 264l12 -108v-252h-186v613h184q13 0 22.5 -1t17 -4.5t14 -9.5t14.5 -16zM560 1457 v-169h-150v-444h-212v444h-148v169h510z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 1468,
    d: "M788 0v544q58 8 108.5 30.5t88 62.5t59.5 98.5t22 138.5q0 162 -84.5 250.5t-247.5 88.5q-164 0 -248 -88.5t-84 -250.5q0 -80 22 -138.5t59.5 -98.5t88 -62.5t108.5 -30.5v-544h-510q-51 0 -81.5 28.5t-30.5 73.5v166h362v110q-90 26 -158.5 76t-114 117t-68.5 148.5 t-23 171.5q0 77 21.5 150t62 137.5t99.5 119t134.5 93.5t166 60.5t194.5 21.5t194.5 -21.5t166 -60.5t134.5 -93.5t99.5 -119t62 -137.5t21.5 -150q0 -90 -23 -171.5t-69 -148.5t-114 -117t-158 -76v-110h362v-166q0 -45 -30.5 -73.5t-81.5 -28.5h-510z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    d: "M266 1333q42 32 85 57.5t90.5 43t102.5 27t122 9.5q96 0 178 -38.5t142 -111.5t94 -177t34 -235q0 -212 -38.5 -383t-116.5 -291t-196 -185t-277 -65q-95 0 -176 31t-140 88t-92.5 138t-33.5 182q0 118 41 218.5t112.5 174t168 115.5t206.5 42q91 0 155 -27t109 -77v37 q0 83 -16 145t-44.5 102.5t-68 60.5t-85.5 20q-33 0 -65 -10t-60.5 -22t-52.5 -22t-42 -10q-17 0 -33.5 9.5t-34.5 38.5zM522 216q42 0 83.5 17.5t78 59t65.5 110t47 169.5q-9 34 -23.5 64.5t-37 54t-55 37t-76.5 13.5q-63 0 -108.5 -23t-74.5 -64.5t-43 -99.5t-14 -127 q0 -101 41.5 -156t116.5 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 1534,
    d: "M614 1457h306l604 -1457h-1514zM453 258h628l-257 698q-12 33 -27.5 75.5t-29.5 92.5q-13 -50 -27.5 -93.5t-27.5 -76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 1376,
    d: "M1336 1457v-251h-150v-1535h-320v1535h-356v-1535h-320v1535h-150v251h1296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 1376,
    d: "M80 1457h1216v-251h-742l464 -598v-88l-465 -599h743v-250h-1216v103q0 22 8 45.5t24 43.5l564 705l-564 696q-17 20 -24.5 44t-7.5 46v103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    d: "M124 783h910v-222h-910v222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 1182,
    d: "M247 624h-73q-23 0 -44 6.5t-37 21t-25.5 37.5t-9.5 56v96h368q33 0 56.5 -15.5t29.5 -38.5l58 -231q16 -48 26 -97.5t17 -100.5q7 39 15.5 78.5t21.5 81.5l344 1129q8 23 30 38.5t52 15.5h206l-546 -1701h-262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 1376,
    d: "M997 214q-54 0 -99.5 13t-83 35.5t-68.5 53t-57 65.5q-27 -35 -58 -65.5t-68.5 -53t-82.5 -35.5t-99 -13q-70 0 -133 28t-110.5 78.5t-75.5 119.5t-28 152q0 82 28 151.5t75.5 119.5t110.5 78t133 28q54 0 99 -13t82.5 -36t68.5 -53.5t58 -64.5q26 34 57 64.5t68.5 53.5 t83 36t99.5 13q70 0 133 -28t110.5 -78t75.5 -119.5t28 -151.5q0 -83 -28 -152t-75.5 -119.5t-110.5 -78.5t-133 -28zM394 456q25 0 47.5 10.5t42 28.5t37.5 43t36 54q-18 29 -36 54t-37.5 43t-42 28.5t-47.5 10.5q-23 0 -44 -7t-37.5 -23t-26.5 -42t-10 -64t10 -64 t26.5 -42t37.5 -23t44 -7zM985 456q23 0 44 7t37.5 23t26 42t9.5 64t-10 64t-26 42t-37.5 23t-43.5 7q-26 0 -48 -10.5t-42 -28.5t-38 -43t-36 -54q18 -29 36 -54t38 -43t42 -28.5t48 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 850,
    d: "M345 1097q10 87 38 156.5t74 118t111.5 75t151.5 26.5q38 0 82.5 -8.5t85.5 -28.5l-14 -147q-1 -11 -4 -23t-9.5 -22.5t-19 -17.5t-31.5 -7q-47 0 -77 -10t-49 -30.5t-29 -51t-15 -70.5l-127 -985q-14 -105 -49 -182t-89 -127.5t-125 -74.5t-156 -24q-38 0 -82.5 8.5 t-85.5 29.5l16 126q2 15 5.5 26.5t11.5 19.5t22.5 12t38.5 4q57 0 93 10t58 31t32 53.5t15 78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    d: "M796 926q34 0 65.5 8t57 18.5t43.5 21.5t24 17l34 -191q-21 -27 -49 -46t-59.5 -31t-66.5 -17.5t-69 -5.5q-53 0 -106.5 14.5t-104.5 32.5t-99 32.5t-90 14.5q-35 0 -67 -7.5t-58.5 -18.5t-44.5 -23t-24 -20l-42 184q21 30 49.5 51t62 34.5t70 19.5t74.5 6 q53 0 106.5 -14.5t104.5 -32.5t99 -32.5t90 -14.5zM796 556q34 0 65.5 7.5t57 18t43.5 21.5t24 18l34 -192q-21 -27 -49 -45.5t-59.5 -30.5t-66.5 -17.5t-69 -5.5q-53 0 -106.5 14.5t-104.5 32t-99 32t-90 14.5q-35 0 -67 -7.5t-58.5 -18.5t-44.5 -22.5t-24 -19.5l-42 184 q21 29 49.5 50t62 34.5t70 19.5t74.5 6q53 0 106.5 -14.5t104.5 -32t99 -32t90 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    d: "M124 966h512l108 204h220l-108 -204h178v-223h-295l-76 -144h371v-222h-487l-117 -223h-220l117 223h-203v222h319l76 144h-395v223z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    d: "M130 878l810 381v-206q0 -23 -13 -43.5t-51 -37.5l-270 -117q-61 -21 -130 -36q36 -8 68.5 -17.5t61.5 -20.5l269 -121q38 -17 51.5 -37.5t13.5 -43.5v-206l-810 384v121zM130 302h810v-222h-810v222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    d: "M1030 878v-121l-810 -384v206q0 23 13.5 43.5t51.5 37.5l269 121q29 11 61.5 20.5t67.5 17.5q-71 15 -129 36l-270 117q-38 17 -51 37.5t-13 43.5v206zM1030 80h-810v222h810v-222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    d: "M100 734l372 804h216l372 -804l-372 -804h-216zM352 734l188 -436q13 -30 22.5 -56.5t17.5 -51.5q8 25 17 51.5t23 56.5l194 436l-194 437q-25 57 -40 107q-8 -25 -18 -51t-22 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2669",
    unicode: "\u2669",
    horizAdvX: 0,
    d: "M-2 1497h4v-1826h-4v1826z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "undercommaaccent",
    horizAdvX: 660,
    d: "M434 -66q16 0 26 -4t14.5 -10.5t6 -13.5t1.5 -13q0 -9 -3.5 -22.5t-14.5 -39.5l-56 -128q-8 -17 -18 -27.5t-23 -16t-29.5 -7t-35.5 -1.5h-110l52 283h190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave.case",
    horizAdvX: 660,
    d: "M224 1798q23 0 40.5 -2.5t31 -8t25.5 -15t25 -23.5l182 -198h-246q-18 0 -31 1t-24.5 4.5t-22 9t-22.5 14.5l-300 218h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis.case",
    horizAdvX: 660,
    d: "M266 1668q0 -32 -12.5 -59t-34.5 -47.5t-51 -32t-62 -11.5q-30 0 -57.5 11.5t-48.5 32t-33.5 47.5t-12.5 59q0 31 12.5 59t33.5 49t48.5 33t57.5 12q33 0 62 -12t51 -33t34.5 -49t12.5 -59zM706 1668q0 -32 -12.5 -59t-33.5 -47.5t-49.5 -32t-60.5 -11.5t-60.5 11.5 t-49.5 32t-33.5 47.5t-12.5 59q0 31 12.5 59t33.5 49t49.5 33t60.5 12t60.5 -12t49.5 -33t33.5 -49t12.5 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron.case",
    horizAdvX: 660,
    d: "M40 1725h580v-171h-580v171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute.case",
    horizAdvX: 660,
    d: "M774 1798l-295 -214q-26 -20 -48.5 -26.5t-56.5 -6.5h-246l181 197q13 15 25.5 24.5t26.5 15.5t31 8t40 2h342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex.case",
    horizAdvX: 660,
    d: "M730 1551h-234q-18 0 -39 5t-35 13l-74 45q-5 2 -9 5t-9 6q-5 -3 -9 -6t-9 -5l-74 -45q-14 -8 -35 -13t-39 -5h-234l244 227h312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.case",
    horizAdvX: 660,
    d: "M-70 1778h234q18 0 39 -5t35 -13l74 -45q5 -3 9 -5.5t9 -6.5q4 3 8.5 6t9.5 6l74 45q14 8 35 13t39 5h234l-244 -227h-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve.case",
    horizAdvX: 660,
    d: "M330 1526q-79 0 -141.5 15t-106 46.5t-67 78.5t-23.5 112h196q0 -43 36.5 -59t105.5 -16t105.5 16t36.5 59h196q0 -57 -23.5 -103.5t-67 -79.5t-106 -51t-141.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent.case",
    horizAdvX: 660,
    d: "M508 1702q0 -34 -14.5 -65t-39 -54t-58 -37t-70.5 -14q-35 0 -66.5 14t-55.5 37t-38 54t-14 65q0 36 14 67.5t38 55.5t55.5 38t66.5 14q37 0 70.5 -14t58 -38t39 -55.5t14.5 -67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring.case",
    horizAdvX: 660,
    d: "M106 1701q0 46 18.5 83.5t49 64t70.5 41t84 14.5q46 0 87 -14.5t72.5 -41t50 -64t18.5 -83.5q0 -44 -18.5 -80.5t-50 -62.5t-72.5 -40t-87 -14q-44 0 -84 14t-70.5 40t-49 62.5t-18.5 80.5zM252 1701q0 -35 19.5 -57.5t60.5 -22.5q36 0 57 22.5t21 57.5q0 38 -21 60 t-57 22q-41 0 -60.5 -22t-19.5 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde.case",
    horizAdvX: 660,
    d: "M454 1729q21 0 35.5 11t14.5 40h168q0 -55 -14.5 -100t-41.5 -77.5t-66 -50t-88 -17.5q-37 0 -72.5 9t-67 20.5t-57.5 20.5t-45 9q-21 0 -34.5 -12.5t-13.5 -40.5h-170q0 55 15 100t42 77.5t66 50.5t87 18q37 0 72.5 -9t67 -20t57.5 -20t45 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut.case",
    horizAdvX: 660,
    d: "M484 1779l-202 -185q-23 -21 -44 -32t-56 -11h-146l124 168q20 26 48.5 43t75.5 17h200zM874 1779l-262 -185q-27 -19 -51 -31t-59 -12h-166l176 168q25 24 55 42t77 18h230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.salt",
    horizAdvX: 660,
    d: "M454 1499q16 0 26 -4t14.5 -10.5t6 -13.5t1.5 -13q0 -10 -5 -26t-22 -56l-81 -187q-15 -34 -41 -43t-65 -9h-110l66 362h210z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u201E",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u201A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0153",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0119",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0107",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE2",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "q",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "o",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "e",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "d",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "c",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "a",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: ".",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: ",",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u201E",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u201A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0153",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0119",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0107",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE2",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "q",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "o",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "e",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "d",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "c",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "a",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: ".",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: ",",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0153",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0119",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0107",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xEB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xEA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xE9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xE8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xE7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "o",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "e",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "d",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "c",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u201E",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u201A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0153",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0119",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0107",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xEB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xEA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xE9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xE8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xE7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xE6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xE5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xE4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xE3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xE2",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xE1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xE0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "q",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "o",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "e",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "d",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "c",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "a",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: ".",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: ",",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u203A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u2039",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u2022",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u2014",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u2013",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0178",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0152",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0106",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xDD",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xC7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xBB",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xB7",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xAD",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xAB",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "y",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "w",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "v",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\\\\\\\\",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "Y",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "W",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "V",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "Q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "O",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "G",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "@",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "-",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\"",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u2206",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u2122",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u201E",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u201D",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u201C",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u201A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u2019",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u2018",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u017D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u017B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0179",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0178",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\xDD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\xBA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\xB0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\xAA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\\\\\\\\",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "Z",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "Y",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "X",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "V",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: ".",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: ",",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "*",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "'",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "&",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\"",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u203A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u2039",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u2022",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u2014",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u2013",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0178",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0152",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0106",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDD",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xC7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xBB",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xB7",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xAD",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xAB",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "y",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "w",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "v",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\\\\\\\\",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "Y",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "W",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "V",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "Q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "O",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "G",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "@",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "-",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\"",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2122",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u203A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2039",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2022",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u201E",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u201D",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u201C",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u201A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2019",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2018",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2014",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2013",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0153",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0152",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0144",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0119",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0107",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0105",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFC",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFA",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF9",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF8",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF6",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF5",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF4",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF3",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF2",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF1",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEB",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEA",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE9",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE8",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE7",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE6",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE5",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE4",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE3",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE2",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE1",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE0",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xBB",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xBA",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xB9",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xB7",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xB5",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xB3",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xB2",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xB0",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xAD",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xAB",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xAA",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "z",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "y",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "x",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "v",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "u",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "t",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "s",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "r",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "q",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "p",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "o",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "n",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "m",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "g",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "e",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "d",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "c",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "a",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "J",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "@",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: ";",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: ":",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: ".",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "-",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: ",",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "*",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "'",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\"",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u2206",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u2122",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u201D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u2019",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u2018",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u017D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u017B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u0179",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\xBA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\xAA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\\\\\\\\",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "Z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "'",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "&",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\"",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u203A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2039",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2022",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2014",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2013",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0178",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0152",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xDD",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xDC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xDB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xDA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xBB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xB9",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xB7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xB3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xB2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xAD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xAB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\\\\\\\\",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Y",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "W",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "U",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "T",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "J",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "@",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "?",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\"",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u203A",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u2039",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u2022",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u2014",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u2013",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xBB",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xB7",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xAD",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xAB",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "-",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u2206",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u2122",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u201D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u2019",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u2018",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u017D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u017B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0179",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xBA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xAA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\\\\\\\\",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "Z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "'",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "&",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\"",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2206",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201E",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201A",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0144",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0119",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0107",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0104",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFC",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC6",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xB5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "u",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "r",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "p",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "n",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "m",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ";",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ":",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "&",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u2206",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0104",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "&",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u203A",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u2039",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u2022",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u2014",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u2013",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0153",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0152",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0119",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0107",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0106",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xF8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xF6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xF5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xF4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xF3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xF2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xF0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xEB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xEA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xE9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xE8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xE7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xC7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xBB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xB7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xAD",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xAB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "w",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "v",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "t",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "o",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "f",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "e",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "d",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "c",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "Q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "O",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "G",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "@",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "-",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2122",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201E",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201D",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201C",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201A",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2018",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0178",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0153",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0152",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0119",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0107",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0106",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xF8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xF6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xF5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xF4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xF3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xF2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xF0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xEB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xEA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xE9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xE8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xE7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xDD",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xC7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xBA",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xB9",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xB3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xB2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xB0",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xAA",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "y",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "w",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "v",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "o",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "e",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "d",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "c",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\\\\\\\\",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Y",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "W",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Q",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "O",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "G",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "@",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "?",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: ".",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: ",",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "*",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "'",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\"",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u2206",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u2122",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u2019",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u2018",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u017D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u017B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0179",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xBA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xAA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\\\\\\\\",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "Z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "'",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "&",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\"",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2206",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201E",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201A",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0153",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0119",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0107",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0105",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0104",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC6",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "d",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "&",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2206",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2122",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2019",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2018",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u017D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u017B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0179",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xBA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xAA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\\\\\\\\",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "Z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "'",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "&",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\"",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0152",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0106",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xDC",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xDB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xDA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xC7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "U",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "Q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "O",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "G",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "@",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2206",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u203A",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2039",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2022",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u201E",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u201A",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2014",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2013",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0153",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0152",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0144",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0119",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0107",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0105",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0104",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFC",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF9",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF8",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF1",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEB",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE9",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE8",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE7",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE6",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE5",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE4",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE3",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE2",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE1",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE0",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC6",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC5",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC4",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC3",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC2",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC1",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xBB",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xB7",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xB5",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xAD",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xAB",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "z",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "y",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "x",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "w",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "v",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "u",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "s",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "r",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "q",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "p",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "o",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "n",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "m",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "g",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "e",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "d",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "c",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "a",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "J",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "@",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ";",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ":",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "/",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "-",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "&",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u2206",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0104",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "&",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2122",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u203A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2039",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2022",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201E",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201D",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201C",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2019",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2018",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2014",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2013",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0152",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0144",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0119",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0107",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0105",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF8",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF1",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE7",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xBB",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xBA",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xB9",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xB7",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xB5",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xB3",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xB2",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xB0",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAD",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAB",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAA",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "z",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "t",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "s",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "n",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "g",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "d",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "c",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ";",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ":",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "*",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "'",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\"",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2206",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2122",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u203A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2039",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2022",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201E",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201D",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201C",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201A",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2019",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2018",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2014",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2013",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0153",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0119",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0107",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0105",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0104",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE6",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE5",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE4",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE3",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE2",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE1",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE0",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC6",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC5",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC4",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC3",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC2",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC1",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC0",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xBB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xBA",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xB9",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xB7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xB3",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xB2",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xB0",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xAD",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xAB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xAA",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "s",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "o",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "g",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "e",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "d",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "c",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "a",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "J",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "A",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "/",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "-",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ",",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "*",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "'",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "&",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\"",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u203A",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2039",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2022",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2014",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2013",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0153",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0152",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0119",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0107",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0106",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xC7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xBB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xB7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xAD",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xAB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "w",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "t",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "o",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "f",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "e",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "d",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "c",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "@",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "-",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2122",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u201E",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u201D",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u201C",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u201A",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2019",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2018",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0153",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0152",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0144",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0119",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0107",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0106",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0105",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFC",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFB",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFA",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF9",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF8",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF6",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF5",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF4",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF3",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF2",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF1",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE9",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE8",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE6",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE5",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE4",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE3",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE2",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE1",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xBA",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xB9",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xB5",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xB3",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xB2",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xB0",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xAA",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "x",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "w",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "u",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "s",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "r",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "o",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "n",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "m",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "g",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "e",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "d",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "c",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "a",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "Q",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "O",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "J",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "G",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "@",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ";",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ",",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "*",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "'",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\"",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u2039",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u2022",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u2014",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u2013",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0153",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0119",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0107",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xF8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xF6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xF5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xF4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xF3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xF2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xEB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xEA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xE9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xE8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xE7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xB7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xAD",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xAB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "y",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "-",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0153",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0119",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0107",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xF8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xF6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xF5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xF4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xF3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xF2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xF0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xEB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xEA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xE9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xE8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xE7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "o",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "e",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "d",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "c",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u203A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u2039",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u2022",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u2014",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u2013",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0178",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0152",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xDD",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xDC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xDB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xDA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xD9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xBB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xB9",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xB7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xB3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xB2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xAD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xAB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\\\\\\\\",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "Y",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "W",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "U",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "T",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "J",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "@",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "?",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\"",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u2122",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u201C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u2018",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xBA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xB9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xB3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xB2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xB0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xAA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "*",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "'",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\"",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2122",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201E",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201D",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201C",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2019",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2018",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xBA",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xB9",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xB3",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xB2",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xB0",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xAA",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ".",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "*",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "'",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\"",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u2122",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u201C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u2018",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xBA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xB9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xB3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xB2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xB0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xAA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "*",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "'",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\"",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0153",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0119",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0107",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xEB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xEA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "o",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "e",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "d",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "c",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u2122",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u201C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u2018",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xBA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xB9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xB3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xB2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xB0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xAA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "*",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "'",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\"",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u2122",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u201C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u2018",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xBA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xB9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xB3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xB2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xB0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xAA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "*",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "'",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\"",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u201E",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u201A",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u0105",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "a",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ",",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2206",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u201E",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u201A",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0153",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0119",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0107",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0104",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xEB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xEA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC1",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "o",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "e",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "d",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "c",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "&",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u201E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u201A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0153",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0119",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0107",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xEB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xEA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "o",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "e",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "d",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "c",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u2206",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u201E",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u201A",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u0153",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u0119",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u0107",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u0104",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xF8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xF6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xF5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xF4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xF3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xF2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xF0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xEB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xEA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xE9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xE8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xE7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xC6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xC5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xC4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xC3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xC2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xC1",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xC0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "o",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "e",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "d",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "c",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "/",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ",",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "&",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0153",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0119",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0107",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xF8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xF6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xF5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xF4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xF3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xF2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xF0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xEB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xEA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xE9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xE8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xE7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "o",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "e",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "d",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "c",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u201E",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u201A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u0153",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u0119",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u0107",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u0105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xF8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xF5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xF4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xF3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xF2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xF0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xEB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xEA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xE9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xE8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xE7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xE6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xE5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xE4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xE3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xE2",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xE1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xE0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "q",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "o",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "e",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "d",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "c",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "a",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: ".",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: ",",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u2206",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u2122",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u201E",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u201D",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u201C",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u201A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u2019",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u2018",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u017D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u017B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0179",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0178",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\xDD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\xBA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\xB0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\xAA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\\\\\\\\",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "Z",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "Y",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "X",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "V",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: ".",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: ",",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "*",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "'",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "&",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\"",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u2206",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u2122",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u201E",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u201D",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u201C",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u201A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u2019",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u2018",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u017D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u017B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u0179",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u0178",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\xDD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\xBA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\xB0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\xAA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\\\\\\\\",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "Z",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "Y",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "X",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "V",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: ".",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: ",",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "*",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "'",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "&",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\"",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u2206",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u2122",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u201D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u2019",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u2018",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u017D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u017B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u0179",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xBA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\xAA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\\\\\\\\",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "Z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "'",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "&",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAE",
    u2: "\"",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u201E",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u201A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u0153",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u0119",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u0107",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u0105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xF8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xF5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xF4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xF3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xF2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xF0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xEB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xEA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xE9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xE8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xE7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xE6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xE5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xE4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xE3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xE2",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xE1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xE0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "q",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "o",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "e",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "d",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "c",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "a",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: ".",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: ",",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "\u2206",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "\u0104",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "\xC6",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "\xC5",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "\xC4",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "\xC3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "\xC2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "\xC1",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "\xC0",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "A",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "/",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB2",
    u2: "&",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "\u2206",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "\u0104",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "\xC6",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "\xC5",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "\xC4",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "\xC3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "\xC2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "\xC1",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "\xC0",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "A",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "/",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB3",
    u2: "&",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\u2206",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\u2122",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\u201E",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\u201D",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\u201C",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\u201A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\u2019",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\u2018",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\u017D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\u017B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\u0179",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\u0178",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\xDD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\xBA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\xB0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\xAA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\\\\\\\\",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "Z",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "Y",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "X",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "V",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: ".",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: ",",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "*",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "'",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "&",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "\"",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "\u2206",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "\u0104",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "\xC6",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "\xC5",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "\xC4",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "\xC3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "\xC2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "\xC1",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "\xC0",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "A",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "/",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB9",
    u2: "&",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u201E",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u201A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u0153",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u0119",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u0107",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u0105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xF8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xF5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xF4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xF3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xF2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xF0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xEB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xEA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xE9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xE8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xE7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xE6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xE5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xE4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xE3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xE2",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xE1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xE0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "q",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "o",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "e",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "d",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "c",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "a",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: ".",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: ",",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u2206",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u2122",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u201E",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u201D",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u201C",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u201A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u2019",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u2018",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u017D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u017B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0179",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0178",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xDD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xBA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xB0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xAA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\\\\\\\\",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "Z",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "Y",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "X",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "V",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: ".",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: ",",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "*",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "'",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "&",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\"",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u203A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2039",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2022",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2014",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2013",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0178",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0152",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xDD",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xDC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xDB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xDA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xBB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xB9",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xB7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xB3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xB2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xAD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xAB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\\\\\\\\",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "Y",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "W",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "V",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "U",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "T",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "J",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "@",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "?",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\"",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u203A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2039",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2022",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2014",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2013",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0178",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0152",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xDD",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xDC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xDB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xDA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xBB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xB9",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xB7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xB3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xB2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xAD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xAB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\\\\\\\\",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "Y",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "W",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "U",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "T",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "J",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "@",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "?",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\"",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u203A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2039",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2022",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2014",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2013",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0178",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0152",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xDD",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xDC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xDB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xDA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xBB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xB9",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xB7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xB3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xB2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xAD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xAB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\\\\\\\\",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "Y",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "W",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "U",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "T",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "J",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "@",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "?",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\"",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u203A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2039",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2022",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2014",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2013",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0178",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0152",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xDD",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xDC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xDB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xDA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xBB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xB9",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xB7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xB3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xB2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xAD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xAB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\\\\\\\\",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "Y",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "W",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "V",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "U",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "T",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "J",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "@",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "?",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\"",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u203A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2039",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2022",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2014",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2013",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0178",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0152",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xDD",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xDC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xDB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xDA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xBB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xB9",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xB7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xB3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xB2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xAD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xAB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\\\\\\\\",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "Y",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "W",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "U",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "T",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "J",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "@",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "?",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\"",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u203A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2039",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2022",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2014",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2013",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0178",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0152",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xDD",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xDC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xDB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xDA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xBB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xB9",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xB7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xB3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xB2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xAD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xAB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\\\\\\\\",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "Y",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "W",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "U",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "T",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "J",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "@",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "?",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\"",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u203A",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u2039",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u2022",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u2014",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u2013",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\xBB",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\xB7",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\xAD",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\xAB",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "-",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u2206",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u2122",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u201D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u2019",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u2018",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u017D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u017B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0179",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xBA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xAA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\\\\\\\\",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "Z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "'",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "&",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\"",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u2206",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u2122",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u201D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u2019",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u2018",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u017D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u017B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0179",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xBA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xAA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\\\\\\\\",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "Z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "'",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "&",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\"",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u2206",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u2122",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u2019",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u2018",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u017D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u017B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0179",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xBA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xAA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\\\\\\\\",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "Z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "'",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "&",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\"",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u2206",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u2122",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u2019",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u2018",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u017D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u017B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0179",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xBA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xAA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\\\\\\\\",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "Z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "'",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "&",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\"",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u2206",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u2122",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u201D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u2019",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u2018",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u017D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u017B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0179",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xBA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xAA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\\\\\\\\",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "Z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "'",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "&",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\"",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u2206",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u2122",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u2019",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u2018",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u017D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u017B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0179",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xBA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xAA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\\\\\\\\",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "Z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "'",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "&",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\"",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u2206",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0104",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xC6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xC5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xC4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xC3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xC2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xC1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xC0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "&",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u2206",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0104",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xC6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xC5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xC4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xC3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xC2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xC1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xC0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "&",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u2206",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0104",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xC6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xC5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xC4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xC3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xC2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xC1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xC0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "&",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u2206",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0104",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xC6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xC5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xC4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xC3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xC2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xC1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xC0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "&",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u2122",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u201E",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u201D",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u201C",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u201A",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u2019",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u2018",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0153",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0152",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0144",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0119",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0107",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0106",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0105",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFC",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFB",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFA",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF9",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF8",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF6",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF5",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF4",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF3",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF2",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF1",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE9",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE8",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE6",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE5",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE4",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE3",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE2",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE1",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xBA",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xB9",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xB5",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xB3",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xB2",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xB0",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xAA",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "x",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "w",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "u",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "s",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "r",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "q",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "p",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "o",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "n",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "m",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "g",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "e",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "d",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "c",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "a",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "Q",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "O",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "J",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "G",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "@",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ";",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ":",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ".",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ",",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "*",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "'",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\"",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2206",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u201D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2019",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2018",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u017D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u017B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0179",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xBA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xAA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "Z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "'",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "&",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\"",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\u2122",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\u201C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\u2018",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\xBA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\xB9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\xB3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\xB2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\xB0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\xAA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "*",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "'",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\"",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\u2122",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\u201C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\u2018",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\xBA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\xB9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\xB3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\xB2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\xB0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\xAA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "*",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "'",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\"",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\u2122",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\u201C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\u2018",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\xBA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\xB9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\xB3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\xB2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\xB0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\xAA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "*",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "'",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\"",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\u2122",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\u201C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\u2018",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\xBA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\xB9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\xB3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\xB2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\xB0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\xAA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "*",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "'",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\"",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u2122",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u201C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u2018",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\xBA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\xB9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\xB3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\xB2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\xB0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\xAA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "*",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "'",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\"",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\u2122",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\u201C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\u2018",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\xBA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\xB9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\xB3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\xB2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\xB0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\xAA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "*",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "'",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\"",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\u2122",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\u201C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\u2018",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\xBA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\xB9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\xB3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\xB2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\xB0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\xAA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "*",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "'",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\"",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u203A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u2039",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u2022",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u2014",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u2013",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0178",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0152",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xDD",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xDC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xDB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xDA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xBB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xB9",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xB7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xB3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xB2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xAD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xAB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\\\\\\\\",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "Y",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "W",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "V",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "U",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "T",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "J",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "@",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "?",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\"",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\u2122",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\u201C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\u2018",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\xBA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\xB9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\xB3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\xB2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\xB0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\xAA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "*",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "'",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\"",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u203A",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u2039",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u2022",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u2014",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u2013",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\xBB",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\xB7",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\xAD",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\xAB",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "-",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u2122",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u203A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u2039",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u2022",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u201D",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u201C",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u2019",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u2018",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u2014",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u2013",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0178",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xDD",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xBB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xBA",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xB9",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xB7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xB3",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xB2",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xB0",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xAD",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xAB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xAA",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "y",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "v",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\\\\\\\\",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "Y",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "W",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "V",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "-",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "*",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "'",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\"",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\u2122",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\u201C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\u2018",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\xBA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\xB9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\xB3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\xB2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\xB0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\xAA",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "*",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "'",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\"",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u2122",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u201D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u201C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u2018",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xBA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xB0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xAA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "}",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "]",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\\\\\\\\",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "V",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "'",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\"",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u2122",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u201E",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u201D",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u201C",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u201A",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u2019",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u2018",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0153",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0152",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0144",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0119",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0107",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0106",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0105",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFC",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFB",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFA",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF9",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF8",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF6",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF5",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF4",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF3",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF2",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF1",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE9",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE8",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE6",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE5",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE4",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE3",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE2",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE1",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xBA",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xB9",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xB5",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xB3",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xB2",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xB0",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xAA",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "x",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "w",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "u",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "s",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "r",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "q",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "p",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "o",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "n",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "m",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "g",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "e",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "d",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "c",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "a",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "Q",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "O",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "J",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "G",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "@",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ";",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ":",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ".",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ",",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "*",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "'",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\"",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u2039",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u2022",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u2014",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u2013",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u0153",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u0119",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u0107",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xF8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xF6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xF5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xF4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xF3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xF2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xEB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xEA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xE9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xE8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xE7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xB7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xAD",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\xAB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "y",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "-",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u2039",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u2022",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u2014",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u2013",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u0153",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u0119",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u0107",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xF8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xF6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xF5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xF4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xF3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xF2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xEB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xEA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xE9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xE8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xE7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xB7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xAD",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\xAB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "y",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "-",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u2039",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u2022",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u2014",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u2013",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u0153",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u0119",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u0107",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xF8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xF6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xF5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xF4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xF3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xF2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xEB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xEA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xE9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xE8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xE7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xB7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xAD",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\xAB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "y",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "-",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u2206",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u2122",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u201E",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u201D",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u201C",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u201A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u2019",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u2018",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u017D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u017B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0179",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0178",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\xDD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\xBA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\xB0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\xAA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\\\\\\\\",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "Z",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "Y",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "X",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "V",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: ".",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: ",",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "*",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "'",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "&",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\"",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u2206",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u2122",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u201E",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u201D",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u201C",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u201A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u2019",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u2018",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u017D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u017B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0179",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0178",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\xDD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\xBA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\xB0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\xAA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\\\\\\\\",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "Z",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "Y",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "X",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "V",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: ".",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: ",",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "*",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "'",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "&",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\"",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u201E",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u201A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0153",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0119",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0107",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE2",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "q",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "o",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "e",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "d",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "c",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "a",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: ".",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: ",",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u201E",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u201A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0153",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0119",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0107",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xEB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xEA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE2",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "q",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "o",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "e",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "d",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "c",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "a",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ".",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ",",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u203A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u2039",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u2022",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u2014",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u2013",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0178",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0152",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0106",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xDD",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xC7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xBB",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xB7",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xAD",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xAB",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "y",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "w",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "v",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\\\\\\\\",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "Y",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "W",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "V",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "Q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "O",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "G",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "@",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "-",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\"",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u201E",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u201A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0153",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0119",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0107",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE2",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "q",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "o",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "e",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "d",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "c",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "a",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: ".",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: ",",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u201E",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u201A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0153",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0119",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0107",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xEB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xEA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE2",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "q",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "o",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "e",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "d",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "c",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "a",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: ".",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: ",",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u203A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u2039",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u2022",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u2014",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u2013",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0178",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0152",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0106",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xDD",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xC7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xBB",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xB7",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xAD",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xAB",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "y",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "w",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "v",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\\\\\\\\",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "Y",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "W",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "Q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "O",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "G",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "@",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "-",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\"",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\u2206",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\u2122",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\u201E",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\u201D",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\u201C",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\u201A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\u2019",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\u2018",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\u017D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\u017B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\u0179",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\u0178",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\xDD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\xBA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\xB0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\xAA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\\\\\\\\",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "Z",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "Y",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "X",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "V",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: ".",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: ",",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "*",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "'",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "&",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2022",
    u2: "\"",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u2206",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u2122",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u201E",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u201D",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u201C",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u201A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u2019",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u2018",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u017D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u017B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0179",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0178",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xDD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xBA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xB0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xAA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\\\\\\\\",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "Z",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "Y",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "X",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "V",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: ".",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: ",",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "*",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "'",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "&",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\"",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u2206",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u2122",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u201E",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u201D",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u201C",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u201A",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u2019",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u2018",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u017D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u017B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0179",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0178",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xDD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xBA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xB0",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xAA",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\\\\\\\\",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "Z",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "Y",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "X",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "V",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "T",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: ".",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: ",",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "*",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "'",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "&",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\"",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u2206",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u203A",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u2039",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u2022",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u201E",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u201A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u2014",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u2013",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u0178",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u0153",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u0119",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u0107",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u0105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\u0104",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xF8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xF5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xF4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xF3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xF2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xF0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xEB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xEA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xE9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xE8",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xE7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xE6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xE5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xE4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xE3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xE2",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xE1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xE0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xDD",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xD8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xC6",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xC5",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xC4",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xC3",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xC2",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xC1",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xC0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xBB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xB7",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xAD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\xAB",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "q",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "o",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "e",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "d",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "c",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "a",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "\\\\\\\\",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "Y",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "W",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "V",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "A",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "@",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "/",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: ".",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: ",",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2122",
    u2: "&",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\u2122",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\u203A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\u2039",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\u2022",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\u201C",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\u2019",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\u2018",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\u2014",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\u2013",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\u0178",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\u0152",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xDD",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xDC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xDB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xDA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xD9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xBB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xBA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xB9",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xB7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xB3",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xB2",
    k: 220
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xB0",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xAD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xAB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\xAA",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\\\\\\\\",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "Y",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "W",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "V",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "U",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "T",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "J",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "@",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "?",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "*",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "'",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2206",
    u2: "\"",
    k: 200
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatoBlack);
export default __webpack_public_path__ + "static/media/Lato-Black.ea702583981d52d68a41e5c839146f38.svg";
export { ForwardRef as ReactComponent };